const messages = {
  en: {
    general: {
      tip: 'Tip',
      confirm: 'Confirm',
      search: 'Search',
      add: 'Add',
      edit: 'Edit',
      delete: 'Delete',
      remove: 'Remove',
      save: 'Save',
      update: 'Update',
      cancel: 'Cancel',
      cancel2: 'Cancel',
      continue: 'Continue',
      activate: 'activate',
      deactivate: 'deactivate',
      active: 'active',
      inactive: 'inactive',
      specialPrice: 'Special Price',
      removePhoto: 'Too many images uploaded',
      yes: 'Yes',
      no: 'No',
      success: 'Success',
      required: 'required',
      back: 'back',
      next: 'Next',
      finish: 'Finish',
      duplicate: 'Duplicate',
      select: 'Select',
      all: 'All',
      alls: 'All',
      reset: 'Reset',
      export: 'Export',
      loadMore: 'Load More',
      viewDetails: 'View Details',
      showing: 'Showing {length} result(s)',
      enable: 'activate',
      disable: 'deactivate',
      product: 'product',
      logout: 'Logout',
      from: 'from',
      to: 'to',
      cancelCourier: 'Cancel courier',
      agree: 'Agree',
      agreePopupMessage: 'To allow the browser to play audio you need to click "Agree". This will play a test sound in order to activate sound play.',
      day: 'day',
      notCompleted: 'not completed',
      saveChanges: 'Save Changes',
      doYouWantToLogout: 'Do you want to logout?',
      minutes: 'minutes',
      hour: 'hour',
      hours: 'hours',
      customSort: 'Company use custom sort',
      deliveryMethod: 'Delivery Methods',
      none: 'None',
      included: 'Included',
      error_fiscal_kiosk: 'Fiscal register error, please call an employee',
      error_not_open_kiosk: 'Is closed!',
      no_internet_kiosk: 'No internet connection',
      reload: 'Reload',
      error_not_open_table: 'You must be at the table to order. Go back to the table and scan again!',
      error_not_open_table_1: 'Your link is not valid. Please go to the table and scan the QR code again',
      error_not_open_table_2: '"Order to the table" service is not available. Please ask the staff',
      error_not_open_table_3: '"Order to the table" service is not available. Please ask the staff',
      error_not_open_table_4: '"Order to the table" service is not available. Please ask the staff',
      error_not_open_table_5: '"Order to the table" service is not available. Please ask the staff',
      error_not_open_table_6: '"Order to the table" service is not available. Please ask the staff',
      error_not_open_table_7: 'Your link is not valid. Please go to the table and scan the QR code again',
      error_not_open_table_8: 'The location is out of working hours. Please wait until opening time',
      error: 'Error',
      errProductLoad: 'The product could not be loaded',
      errProductsLoad: 'The products could not be loaded',
      errOrderMethod: 'Your dining choice could not be saved. Please try again.',
      errPaymentProfileLoad: 'Payment methods could not be loaded',
      loyaltyPoints: 'Loyalty points:',
      loyaltyPointsText: 'Total Loyalty Points',
      applyLoyalty: 'Apply Points',
      removeLoyalty: 'Remove Points',
      walletTotalText: 'Total in wallet',
      applyWallet: 'Pay from Wallet',
      removeWallet: 'Remove money from wallet from order',
      walletAppNot1: 'Waiting for approval from the app...',
      walletAppNot2: 'If you did not receive the notification or notifications are not enabled in the app, go to your account and tap the two-factor authentication option.',
      walletAppNotErr1: 'Error sending code',
      walletAppNotErr2: '2FA verification error',
      walletAppNotErr3: 'The request was rejected',
      selectWalletValue: 'Select the value you want to use',
      selectWalletValueErr: 'You just have ',
      selectWalletValueErr2: 'You have products in your cart worth ',
      walletPay: 'Pay From Wallet:',
    },
    addOrder: {
      'pleaseWait': 'Please wait',
      'pleaseWaitFiscalReceipt': 'Please wait for the fiscal receipt',
      'selectTip': 'Select Tip',
      'customTip': 'Custom Amount',
      'enterCustomTip': 'Enter Custom Tip',
      'tipAdded': 'Tip Added',
      'removeTip': 'Remove Tip',
      'outOfStock': 'Out Of Stock',
      'available': 'available',
      'sufficientStock': 'Sufficient stock',
      'productNoStock': 'Product is out of stock',
      'unavailable': 'Unavailable',
      'productUnavailable': 'The product is currently unavailable',
      'addPager': 'Please enter a pager before payment',
      'vivaPaySuccess': 'Thank you, the payment was made successfully!',
      'cart_lost': 'Another Kiosk has been detected.',
      'cart_lost_title': 'A problem occurred',
      'err1': 'Please select the products you want to pay for!',
      'askcashtxt': 'In a few moments a waiter will come to collect your payment',
      'waiter_called': 'The waiter has been announced and will come shortly',
      'back': 'Back',
      'titlePopupEditFgpName': 'What is your name?',
      'addPopupEditFgpName': 'Save',
      'askFirstNameTitle': 'What is your first name?',
      'askFirstNameRequired': 'Please enter your first name',
      'waitingOpenOrder': 'Your order is being prepared and will be ready in a few moments.',
      'close': 'Close',
      'allSelect': 'Select all',
      'inProcesing': 'In processing',
      'inPrepared': 'Prepared',
      'deselectAll': 'Deselect all',
      'openOrder': 'Place the order',
      'openOrderNotAvailable': 'Not all products are sent',
      'productNavbar': 'Product',
      'menuNavbar': 'Menu',
      'payNavbar': 'Pay',
      'optionNavar': 'Options',
      'chooseLanguage': 'Choose Your Language',
      'tip': 'Tips',
      'tipsValue': 'Enter value:',
      'splashScreenOrderNow': 'Order now',
      'ordersHistory': 'View order history:',
      'orderNew': 'Order new',
      'addToCart': 'The product has been added to cart',
      'order_id_freeze': 'The payment has been initiated. Please proceed with the payment or wait for the payment link to expire to modify the order!',
      'euPlatesc_error1': 'Authentication failed',
      'euPaysc_error2': 'Insufficient funds',
      'euPaycesc_error3': 'Transaction failed',
      'euPaycesc_error4': 'Card expired',
      'euPlatesc_error5': 'Invalid response',
      "noProductsMessage": "At this time, there are no products available in this category.",
      'relogin': 'Is there anyone else at the table? If it is not, delete the previous order!',
      'deleteOrder': 'Delete',
      'couninueOrder': 'Contiune',
      'errorRelogin': 'There is an open order! Please address the waiter to close the order!',
      'finishOrderMsg': 'Your order has been successfully placed! Stay at the table, well take care of everything!',
      'errorFinishOrderMsg': 'Payment failed! Please check the data entered for payment! Try again or ask the waiter!',
      'payByCard': 'Pay with card',
      'payByCashMachine': 'Insert the bills into the machine',
      'payByCashMachineDone': 'Please wait!',
      'howPay': 'How do you want to pay?',
      'posGeneralError': 'Transaction failed!',
      'selectMinMax': 'You can select',
      'selectMin': ' minumum',
      'selectMax': ' maximum',
      'cartBtn': 'My Cart',
      'emptyCartBtn': 'Empty Cart',
      'splashScreenWrapperStart': 'Tap the screen to start an order',
      'swipeUpTooltip': 'Swipe to the next category',
      'resetQuestion': 'Do you want to start from the beginning?',
      'emptyCart': 'Do you want to delete all products from cart?',
      'emptyCartProduct': 'Do you want to delete product from cart?',
      'yes': 'Yes',
      'no': 'No',
      'reorderPopupQuestion': 'Would you like to order something else?',
      'jumpOver': 'Skip',
      'soldWithAdd': 'Add',
      'soldWithNo': 'No, thank you',
      'soldWithExtra': 'Total extra',
      'placeholderWaiter': '(eg bill of payment)',
      'sendWaiterValidate': 'You must enter a reason!',
      'sendWaiter': 'Do you want to call the waiter?',
      'soldWithTitle': 'Recommendation',
      'menuCombo': 'Would you like to go for the meal option?',
      'couponExit': 'Tap anywhere to exit',
      'couponTitle': 'Enter coupon code',
      'enterCui': 'Enter the CUI',
      'noProductsFound': 'Searched products were not found.',
      'couponPlaceholder': 'Type coupon code',
      'pagerTitle': 'Scan the QR code on the pager',
      'pagerPlaceholder': 'Pager code',
      'pagerBtn': 'Add Pager',
      'couponBtn': 'Apply coupon:',
      'commentBtn': 'Additional Information:',
      'couponButton': 'Apply',
      'couponBtn2': 'Got a promotional code?',
      'orderNumber': 'Order number',
      'step1': 'Wait for your order nuber to appear on the screen',
      'step2': 'Pick up your order at the cash desk',
      'yourOrderNr': 'Order number',
      'doneShortly': 'Your order is being prepared.',
      'thenks': 'Thank you!',
      'qrStep1': 'Step 1: Scan the QR code with your smartphone camera.',
      'qrStep2': 'Step 2: Go to the link, fill in the fields (card number, email) and check the boxes. Warning! Terms and conditions acceptance is mandatory, otherwise payment cannot be made.',
      'qrStep3': 'Step 3: Click on the Pay online button',
      'qrStep4': 'Step 4: In a few seconds you will receive the payment confirmation.',
      'qrCancel': 'Cancel',
      'qrText': 'You have ',
      'qrText2': 'seconds to pay the order or the order will be cancelled',
      'backShopping': 'Back to menu',
      'qr': 'Online by scanning the QR code',
      'cash_waiter': 'Cash to the waiter',
      'cash_bar': 'Cash at the bar',
      'pos_waiter': 'POS to the waiter',
      'pos_bar': 'CARD/POS at the bar',
      'card': 'Online payment',
      'counter': 'At the cashier',
      'counter_cash': 'At the cashier cash',
      'counter_pos': 'At the cashier POS',
      'pack': 'Where will you be eating today?',
      'takeAway': 'Take Away',
      'takeAway_first': 'Take',
      'takeAway_second': 'Away',
      'dineIn': 'Eat In',
      'dineIn_first': 'Eat',
      'dineIn_second': 'In',
      'paymentOptions': 'Payment Options',
      'posOffline': 'The card terminal is disconnected',
      'posRetry': 'Retry',
      'weitingForAddToCartToFinish': 'The total is being calculated',
      'empty': 'Your cart is empty',
      'backToMenu': 'Back to menu',
      'total': 'Total:',
      'search': 'Search',
      'titleClient': 'Customer',
      'titleMethod': 'Delivery method',
      'titleLocation': 'Location',
      'titleAdress': 'Delivery address',
      'titleStatus': 'Status',
      'done': 'Done',
      'datepicker': 'Pick a date',
      'hourpicker': 'Pick a hour',
      'how_many': 'For how many people the reservation is made',
      'tags': 'Order from',
      'titlePopupTip': 'Add Value',
      'btnPopup': 'Add',
      'titlePopupCoupon': 'Add coupon',
      'errorPopupCoupon': 'Wrong coupon',
      'errorProduct1': 'The products are no longer available and have been deleted from the cart',
      'errorProduct2': 'One or more products are no longer available and have been deleted from the cart',
      'errorProduct3': 'You must have products in your cart to be able to order!',
      'errorProduct4': 'Please select the method and location',
      'errorProduct5': 'Please add a customer',
      'errorProduct6': 'Payment method not selected',
      'errorProduct7': 'Please add an adress',
      'add': 'Add',
      'addFor': 'Add for ',
      'edit': 'Edit',
      'next_to_option': 'Add',
      'prev_to_option': 'Prev',
      'infosup': 'Add additional information',
      'guest': 'Guest',
      'newScan': 'To start a new order, please scan again.',
      'state': 'County',
      'city': 'Town',
      'adress': 'Block, staircase, floor, apartment',
      'number': 'Number',
      'street': 'Street',
      'adressname': 'Address Name',
      'sexf': 'Female',
      'sexm': 'Male',
      'sex': 'Sex',
      'birthdate': 'Date of birth',
      'contactperson': 'Contact person',
      'newclient': 'Add or choose client',
      'newadress': 'Add or choose the address',
      'save1': 'Choose and save changes',
      'deliveryAdress': 'Add address',
      'deliveryAdressEdit': 'Edit adresa',
      'firstName': 'First name',
      'lastName': 'Last name',
      'contactPers': 'Contact person',
      'clientSelected': 'Selected customer',
      'clearFields': 'Clear the fields',
      'addAdress': '+ Add the address',
      'existingClient': 'Order from',
      'orderNow': 'Pay',
      'orderNowDesc': '⚠️ Please pay only right before you leave. Until then, you can continue ordering other products from the menu.',
      'viva_walet': 'With card on device',
      'vivaWaitingText': 'Waiting for the Viva app to open...',
      'vivaRetryButton': 'Retry',
      'vivaCancelButton': 'Cancel',
      'pos': 'With card',
      'cash': 'Cash',
      'free': 'Free',
      'coment': 'Comment Order',
      'addTip': 'Add tip:',
      'addTipValue': 'Enter the amount',
      'addTipButton': 'Add',
      'removeTip': 'Remove tip',
      'removeTipButton': 'Remove',
      'addCoupon': 'Add discount coupon',
      'removeCoupon': 'Delete coupon',
      'removeCouponButton': 'Delete',
      'modif': 'Edit',
      'delete': 'Delete',
      'freeProd': 'Free Product',
      'info': 'Info',
      'orderDet': 'Order Details',
      'cartDet': 'My Cart',
      'fast': 'As soon as possible',
      'selectHour': 'Select the time',
      'selectPayment': 'Select the payment method',
      'pleaseSelectMethodAndLoc': 'Please select the method and location!',
      'locSelect': 'Select a location',
      'searchProduct': 'search products',
      'phone': 'Phone',
      'email': 'E-mail',
      'inlocation': 'In Location',
      'cuiPlaceholder': 'Enter VAT Number',
      'emailFieldsTitle1': 'Ajută-ne să îmbunătățim experiența',
      'emailFieldsTitle2': 'Lasă-ne un email pentru a-ți trimite confirmarea comenzii!',
      'emailPlaceholder': 'Adresa e-mail',
      'phonePlaceholder': 'Phone Number',
      'phoneFieldsTitle1': 'Enter the phone number:',
      'phoneSearch': 'Add',
      'client': 'Client:',
      'newClient': 'New client:',
      'phoneFidelityTitle': 'Load loyalty points?',
      'phoneFieldsTitle2': 'Or scan the QR code from the application',
      'phoneError': 'Phone invalid',
      'qrError': 'Invalid Qr code, scan again or enter the phone number!',
      'emailError': 'Email invalid',
      'adressNotInRange': 'Not in range, please change the adress!',
      'adressNotCorect': 'Adress is not correct',
      'continueToPay': 'Proceed to Payment',
      'loyalityNoSms': 'Want loyalty points?',
      'noLoyalitySms': 'Do you want to know when the order is ready?',
      'loyalitySms': 'Want to know when your order is ready and get loyalty points?',
      'new_client_fidelity': 'After creating an in-app account with this phone number, loyalty points will be automatically allocated to that account.',
      'cardDesc1': 'Card payment processing',
      'cardDesc2': 'Please wait a few moments while your transaction is processed',
      'cardDesc3': 'Thank you for your patience!'
    }
  },
  es: {
    general: {
      tip: 'Propina',
      confirm: 'Confirmar',
      search: 'Buscar',
      add: 'Añadir',
      edit: 'Editar',
      delete: 'Eliminar',
      remove: 'Quitar',
      save: 'Guardar',
      update: 'Actualizar',
      cancel: 'Cancelar',
      cancel2: 'Cancelar',
      continue: 'Continuar',
      activate: 'activar',
      deactivate: 'desactivar',
      active: 'activo',
      inactive: 'inactivo',
      specialPrice: 'Precio especial',
      removePhoto: 'Se han subido demasiadas imágenes',
      yes: 'Sí',
      no: 'No',
      success: 'Éxito',
      required: 'obligatorio',
      back: 'atrás',
      next: 'Siguiente',
      finish: 'Finalizar',
      duplicate: 'Duplicar',
      select: 'Seleccionar',
      all: 'Todo',
      alls: 'Todos',
      reset: 'Restablecer',
      export: 'Exportar',
      loadMore: 'Cargar más',
      viewDetails: 'Ver detalles',
      showing: 'Mostrando {length} resultado(s)',
      enable: 'activar',
      disable: 'desactivar',
      product: 'producto',
      logout: 'Cerrar sesión',
      from: 'desde',
      to: 'hasta',
      cancelCourier: 'Cancelar repartidor',
      agree: 'Aceptar',
      agreePopupMessage: 'Para permitir que el navegador reproduzca audio, debes hacer clic en "Aceptar". Se reproducirá un sonido de prueba para activar la reproducción de audio.',
      day: 'día',
      notCompleted: 'no completado',
      saveChanges: 'Guardar cambios',
      doYouWantToLogout: '¿Quieres cerrar sesión?',
      minutes: 'minutos',
      hour: 'hora',
      hours: 'horas',
      customSort: 'La empresa utiliza un orden personalizado',
      deliveryMethod: 'Métodos de entrega',
      none: 'Ninguno',
      included: 'Incluido',
      error_fiscal_kiosk: 'Error de la caja registradora, llama a un empleado',
      error_not_open_kiosk: '¡Está cerrado!',
      no_internet_kiosk: 'Sin conexión a internet',
      reload: 'Recargar',
      error_not_open_table: 'Debes estar en la mesa para pedir. Vuelve a la mesa y escanea de nuevo.',
      error_not_open_table_1: 'Tu enlace no es válido. Vuelve a la mesa y escanea de nuevo el código QR.',
      error_not_open_table_2: 'El servicio "Pedido a la mesa" no está disponible. Consulta al personal.',
      error_not_open_table_3: 'El servicio "Pedido a la mesa" no está disponible. Consulta al personal.',
      error_not_open_table_4: 'El servicio "Pedido a la mesa" no está disponible. Consulta al personal.',
      error_not_open_table_5: 'El servicio "Pedido a la mesa" no está disponible. Consulta al personal.',
      error_not_open_table_6: 'El servicio "Pedido a la mesa" no está disponible. Consulta al personal.',
      error_not_open_table_7: 'Tu enlace no es válido. Vuelve a la mesa y escanea de nuevo el código QR.',
      error_not_open_table_8: 'El local está fuera del horario de apertura. Espera hasta que abra.',
      error: 'Error',
      errProductLoad: 'No se pudo cargar el producto',
      errProductsLoad: 'No se pudieron cargar los productos',
      errOrderMethod: 'No se pudo guardar dónde deseas comer. Inténtalo de nuevo.',
      errPaymentProfileLoad: 'No se pudieron cargar los métodos de pago',
      loyaltyPoints: 'Puntos de fidelidad:',
      loyaltyPointsText: 'Total de puntos de fidelidad',
      applyLoyalty: 'Aplicar puntos',
      removeLoyalty: 'Quitar puntos',
      walletTotalText: 'Total en la cartera',
      applyWallet: 'Pagar con la cartera',
      removeWallet: 'Quitar del pedido el dinero de la cartera',
      walletAppNot1: 'Esperando la aprobación desde la aplicación...',
      walletAppNot2: 'Si no has recibido la notificación o las notificaciones no están activadas en la aplicación, ve a tu cuenta y pulsa la opción de autenticación de dos factores.',
      walletAppNotErr1: 'Error al enviar el código',
      walletAppNotErr2: 'Error de verificación 2FA',
      walletAppNotErr3: 'La solicitud ha sido rechazada',
      selectWalletValue: 'Selecciona el importe que quieres utilizar',
      selectWalletValueErr: 'Solo tienes ',
      selectWalletValueErr2: 'Tienes productos en el carrito por valor de ',
      walletPay: 'Pagar con la cartera:',
    },
    addOrder: {
      'pleaseWait': 'Por favor, espere',
      'pleaseWaitFiscalReceipt': 'Por favor, espere el recibo fiscal',
      'selectTip': 'Seleccionar propina',
      'customTip': 'Importe personalizado',
      'enterCustomTip': 'Introduce una propina personalizada',
      'tipAdded': 'Propina añadida',
      'removeTip': 'Quitar propina',
      'outOfStock': 'Agotado',
      'available': 'disponible',
      'sufficientStock': 'Stock suficiente',
      'productNoStock': 'El producto está agotado',
      'unavailable': 'No disponible',
      'productUnavailable': 'El producto no está disponible actualmente',
      'addPager': 'Introduce un localizador antes del pago',
      'vivaPaySuccess': '¡Gracias, el pago se ha realizado correctamente!',
      'cart_lost': 'Se ha detectado otro quiosco.',
      'cart_lost_title': 'Se ha producido un problema',
      'err1': '¡Selecciona los productos que quieres pagar!',
      'askcashtxt': 'En unos instantes, un camarero vendrá a cobrarte',
      'waiter_called': 'Se ha avisado al camarero y llegará en breve',
      'back': 'Atrás',
      'titlePopupEditFgpName': '¿Cómo te llamas?',
      'addPopupEditFgpName': 'Guardar',
      'askFirstNameTitle': '¿Cuál es tu nombre?',
      'askFirstNameRequired': 'Por favor, introduce tu nombre',
      'waitingOpenOrder': 'Tu pedido se está preparando y estará listo en unos instantes.',
      'close': 'Cerrar',
      'allSelect': 'Seleccionar todo',
      'inProcesing': 'En preparación',
      'inPrepared': 'Preparado',
      'deselectAll': 'Deseleccionar todo',
      'openOrder': 'Realizar el pedido',
      'openOrderNotAvailable': 'No se han enviado todos los productos',
      'productNavbar': 'Producto',
      'menuNavbar': 'Menú',
      'payNavbar': 'Pagar',
      'optionNavar': 'Opciones',
      'chooseLanguage': 'Elige tu idioma',
      'tip': 'Propinas',
      'tipsValue': 'Introduce el importe:',
      'splashScreenOrderNow': 'Pedir ahora',
      'ordersHistory': 'Ver historial de pedidos:',
      'orderNew': 'Nuevo pedido',
      'addToCart': 'El producto se ha añadido al carrito',
      'order_id_freeze': 'El pago se ha iniciado. Continúa con el pago o espera a que caduque el enlace de pago para modificar el pedido.',
      'euPlatesc_error1': 'Error de autenticación',
      'euPaysc_error2': 'Fondos insuficientes',
      'euPaycesc_error3': 'Transacción fallida',
      'euPaycesc_error4': 'Tarjeta caducada',
      'euPlatesc_error5': 'Respuesta no válida',
      'noProductsMessage': 'En este momento no hay productos disponibles en esta categoría.',
      'relogin': '¿Hay alguien más en la mesa? Si no, elimina el pedido anterior.',
      'deleteOrder': 'Eliminar',
      'couninueOrder': 'Continuar',
      'errorRelogin': 'Hay un pedido abierto. Pide al camarero que lo cierre.',
      'finishOrderMsg': '¡Tu pedido se ha realizado correctamente! Quédate en la mesa; nosotros nos ocupamos de todo.',
      'errorFinishOrderMsg': '¡El pago ha fallado! Comprueba los datos introducidos para el pago. Inténtalo de nuevo o pregunta al camarero.',
      'payByCard': 'Pagar con tarjeta',
      'payByCashMachine': 'Introduce los billetes en la máquina',
      'payByCashMachineDone': '¡Espera, por favor!',
      'howPay': '¿Cómo quieres pagar?',
      'posGeneralError': '¡Transacción fallida!',
      'selectMinMax': 'Puedes seleccionar',
      'selectMin': ' como mínimo',
      'selectMax': ' como máximo',
      'cartBtn': 'Mi carrito',
      'emptyCartBtn': 'Vaciar carrito',
      'splashScreenWrapperStart': 'Toca la pantalla para iniciar un pedido',
      'swipeUpTooltip': 'Desliza para ir a la siguiente categoría',
      'resetQuestion': '¿Quieres empezar desde el principio?',
      'emptyCart': '¿Quieres eliminar todos los productos del carrito?',
      'emptyCartProduct': '¿Quieres eliminar el producto del carrito?',
      'yes': 'Sí',
      'no': 'No',
      'jumpOver': 'Omitir',
      'soldWithAdd': 'Añadir',
      'soldWithNo': 'No, gracias',
      'soldWithExtra': 'Total adicional',
      'placeholderWaiter': '(p. ej., justificante de pago)',
      'sendWaiterValidate': '¡Debes indicar un motivo!',
      'sendWaiter': '¿Quieres llamar al camarero?',
      'soldWithTitle': 'Recomendación',
      'menuCombo': '¿Quieres elegir la opción de menú?',
      'couponExit': 'Toca en cualquier lugar para salir',
      'couponTitle': 'Introduce el código del cupón',
      'enterCui': 'Introduce el CUI',
      'noProductsFound': 'No se han encontrado los productos buscados.',
      'couponPlaceholder': 'Escribe el código del cupón',
      'pagerTitle': 'Escanea el código QR del localizador',
      'pagerPlaceholder': 'Código del localizador',
      'pagerBtn': 'Añadir localizador',
      'couponBtn': 'Aplicar cupón:',
      'commentBtn': 'Información adicional:',
      'couponButton': 'Aplicar',
      'couponBtn2': '¿Tienes un código promocional?',
      'orderNumber': 'Número de pedido',
      'step1': 'Espera a que el número de tu pedido aparezca en la pantalla',
      'step2': 'Recoge tu pedido en la caja',
      'yourOrderNr': 'Número de pedido',
      'doneShortly': 'Tu pedido se está preparando.',
      'thenks': '¡Gracias!',
      'qrStep1': 'Paso 1: Escanea el código QR con la cámara de tu teléfono.',
      'qrStep2': 'Paso 2: Abre el enlace, completa los campos (número de tarjeta y correo electrónico) y marca las casillas. ¡Atención! Es obligatorio aceptar los términos y condiciones; de lo contrario, no se podrá realizar el pago.',
      'qrStep3': 'Paso 3: Pulsa el botón Pagar en línea',
      'qrStep4': 'Paso 4: En unos segundos recibirás la confirmación del pago.',
      'qrCancel': 'Cancelar',
      'qrText': 'Tienes ',
      'qrText2': 'segundos para pagar el pedido; de lo contrario, se cancelará',
      'backShopping': 'Volver al menú',
      'qr': 'En línea escaneando el código QR',
      'cash_waiter': 'Efectivo al camarero',
      'cash_bar': 'Efectivo en la barra',
      'pos_waiter': 'TPV con el camarero',
      'pos_bar': 'TARJETA/TPV en la barra',
      'card': 'Pago en línea',
      'counter': 'En la caja',
      'counter_cash': 'En efectivo en la caja',
      'counter_pos': 'Con TPV en la caja',
      'pack': '¿Dónde vas a comer hoy?',
      'takeAway': 'Para llevar',
      'takeAway_first': 'Para',
      'takeAway_second': 'llevar',
      'dineIn': 'Comer aquí',
      'dineIn_first': 'Comer',
      'dineIn_second': 'aquí',
      'paymentOptions': 'Opciones de pago',
      'posOffline': 'El terminal de tarjeta está desconectado',
      'posRetry': 'Reintentar',
      'weitingForAddToCartToFinish': 'Se está calculando el total',
      'empty': 'Tu carrito está vacío',
      'backToMenu': 'Volver al menú',
      'total': 'Total:',
      'search': 'Buscar',
      'titleClient': 'Cliente',
      'titleMethod': 'Método de entrega',
      'titleLocation': 'Ubicación',
      'titleAdress': 'Dirección de entrega',
      'titleStatus': 'Estado',
      'done': 'Listo',
      'datepicker': 'Selecciona una fecha',
      'hourpicker': 'Selecciona una hora',
      'how_many': 'Para cuántas personas es la reserva',
      'tags': 'Pedir desde',
      'titlePopupTip': 'Añadir importe',
      'btnPopup': 'Añadir',
      'titlePopupCoupon': 'Añadir cupón',
      'errorPopupCoupon': 'Cupón incorrecto',
      'errorProduct1': 'Los productos ya no están disponibles y se han eliminado del carrito',
      'errorProduct2': 'Uno o varios productos ya no están disponibles y se han eliminado del carrito',
      'errorProduct3': '¡Debes tener productos en el carrito para poder realizar el pedido!',
      'errorProduct4': 'Selecciona el método y la ubicación',
      'errorProduct5': 'Añade un cliente',
      'errorProduct6': 'No se ha seleccionado el método de pago',
      'errorProduct7': 'Añade una dirección',
      'add': 'Añadir',
      'addFor': 'Añadir por ',
      'edit': 'Editar',
      'next_to_option': 'Añadir',
      'prev_to_option': 'Anterior',
      'infosup': 'Añadir información adicional',
      'guest': 'Invitado',
      'newScan': 'Para iniciar un nuevo pedido, vuelve a escanear.',
      'state': 'Provincia',
      'city': 'Localidad',
      'adress': 'Bloque, escalera, planta, apartamento',
      'number': 'Número',
      'street': 'Calle',
      'adressname': 'Nombre de la dirección',
      'sexf': 'Mujer',
      'sexm': 'Hombre',
      'sex': 'Sexo',
      'birthdate': 'Fecha de nacimiento',
      'contactperson': 'Persona de contacto',
      'newclient': 'Añadir o elegir cliente',
      'newadress': 'Añadir o elegir la dirección',
      'save1': 'Elegir y guardar los cambios',
      'deliveryAdress': 'Añadir dirección',
      'deliveryAdressEdit': 'Editar dirección',
      'firstName': 'Nombre',
      'lastName': 'Apellidos',
      'contactPers': 'Persona de contacto',
      'clientSelected': 'Cliente seleccionado',
      'clearFields': 'Borrar los campos',
      'addAdress': '+ Añadir la dirección',
      'existingClient': 'Pedir desde',
      'orderNow': 'Pagar',
      'orderNowDesc': '⚠️ Paga únicamente justo antes de irte. Hasta entonces, puedes seguir pidiendo otros productos del menú.',
      'viva_walet': 'Con tarjeta en el dispositivo',
      'vivaWaitingText': 'Esperando a que se abra la aplicación Viva...',
      'vivaRetryButton': 'Reintentar',
      'vivaCancelButton': 'Cancelar',
      'pos': 'Con tarjeta',
      'cash': 'Efectivo',
      'free': 'Gratis',
      'coment': 'Comentario del pedido',
      'addTip': 'Añadir propina:',
      'addTipValue': 'Introduce el importe',
      'addTipButton': 'Añadir',
      'removeTip': 'Quitar propina',
      'removeTipButton': 'Quitar',
      'addCoupon': 'Añadir cupón de descuento',
      'removeCoupon': 'Eliminar cupón',
      'removeCouponButton': 'Eliminar',
      'modif': 'Editar',
      'delete': 'Eliminar',
      'freeProd': 'Producto gratis',
      'info': 'Información',
      'orderDet': 'Detalles del pedido',
      'cartDet': 'Mi carrito',
      'fast': 'Lo antes posible',
      'selectHour': 'Selecciona la hora',
      'selectPayment': 'Selecciona el método de pago',
      'pleaseSelectMethodAndLoc': '¡Selecciona el método y la ubicación!',
      'locSelect': 'Selecciona una ubicación',
      'searchProduct': 'buscar productos',
      'phone': 'Teléfono',
      'email': 'Correo electrónico',
      'inlocation': 'En el local',
      'cuiPlaceholder': 'Introduce el número de IVA',
      'emailFieldsTitle1': 'Ayúdanos a mejorar la experiencia',
      'emailFieldsTitle2': 'Déjanos un correo electrónico para enviarte la confirmación del pedido.',
      'emailPlaceholder': 'Dirección de correo electrónico',
      'phonePlaceholder': 'Número de teléfono',
      'phoneFieldsTitle1': 'Introduce el número de teléfono:',
      'phoneSearch': 'Añadir',
      'client': 'Cliente:',
      'newClient': 'Nuevo cliente:',
      'phoneFidelityTitle': '¿Cargar los puntos de fidelidad?',
      'phoneFieldsTitle2': 'O escanea el código QR desde la aplicación',
      'phoneError': 'Número de teléfono no válido',
      'qrError': 'Código QR no válido. Vuelve a escanearlo o introduce el número de teléfono.',
      'emailError': 'Correo electrónico no válido',
      'adressNotInRange': 'Está fuera del área de entrega. Cambia la dirección.',
      'adressNotCorect': 'La dirección no es correcta',
      'continueToPay': 'Continuar con el pago',
      'loyalityNoSms': '¿Quieres puntos de fidelidad?',
      'noLoyalitySms': '¿Quieres saber cuándo está listo el pedido?',
      'loyalitySms': '¿Quieres saber cuándo está listo tu pedido y obtener puntos de fidelidad?',
      'new_client_fidelity': 'Después de crear una cuenta en la aplicación con este número de teléfono, los puntos de fidelidad se asignarán automáticamente a esa cuenta.',
      'cardDesc1': 'Procesando el pago con tarjeta',
      'cardDesc2': 'Espera unos instantes mientras se procesa la transacción',
      'cardDesc3': '¡Gracias por tu paciencia!'
    }
  },
  el: {
    general: {
      tip: 'Φιλοδώρημα',
      confirm: 'Επιβεβαίωση',
      search: 'Αναζήτηση',
      add: 'Προσθήκη',
      edit: 'Επεξεργασία',
      delete: 'Διαγραφή',
      remove: 'Αφαίρεση',
      save: 'Αποθήκευση',
      update: 'Ενημέρωση',
      cancel: 'Ακύρωση',
      cancel2: 'Ακύρωση',
      continue: 'Συνέχεια',
      activate: 'ενεργοποίηση',
      deactivate: 'απενεργοποίηση',
      active: 'ενεργό',
      inactive: 'ανενεργό',
      specialPrice: 'Ειδική τιμή',
      removePhoto: 'Έχουν μεταφορτωθεί πάρα πολλές εικόνες',
      yes: 'Ναι',
      no: 'Όχι',
      success: 'Επιτυχία',
      required: 'υποχρεωτικό',
      back: 'πίσω',
      next: 'Επόμενο',
      finish: 'Ολοκλήρωση',
      duplicate: 'Δημιουργία αντιγράφου',
      select: 'Επιλογή',
      all: 'Όλα',
      alls: 'Όλα',
      reset: 'Επαναφορά',
      export: 'Εξαγωγή',
      loadMore: 'Φόρτωση περισσότερων',
      viewDetails: 'Προβολή λεπτομερειών',
      showing: 'Εμφανίζονται {length} αποτέλεσμα(τα)',
      enable: 'ενεργοποίηση',
      disable: 'απενεργοποίηση',
      product: 'προϊόν',
      logout: 'Αποσύνδεση',
      from: 'από',
      to: 'έως',
      cancelCourier: 'Ακύρωση διανομέα',
      agree: 'Συμφωνώ',
      agreePopupMessage: 'Για να επιτρέψετε στο πρόγραμμα περιήγησης να αναπαράγει ήχο, πρέπει να κάνετε κλικ στο "Συμφωνώ". Θα αναπαραχθεί ένας δοκιμαστικός ήχος για την ενεργοποίηση της αναπαραγωγής ήχου.',
      day: 'ημέρα',
      notCompleted: 'μη ολοκληρωμένο',
      saveChanges: 'Αποθήκευση αλλαγών',
      doYouWantToLogout: 'Θέλετε να αποσυνδεθείτε;',
      minutes: 'λεπτά',
      hour: 'ώρα',
      hours: 'ώρες',
      customSort: 'Η εταιρεία χρησιμοποιεί προσαρμοσμένη ταξινόμηση',
      deliveryMethod: 'Τρόποι παράδοσης',
      none: 'Κανένα',
      included: 'Περιλαμβάνεται',
      error_fiscal_kiosk: 'Σφάλμα ταμειακής μηχανής, καλέστε έναν υπάλληλο',
      error_not_open_kiosk: 'Είναι κλειστό!',
      no_internet_kiosk: 'Δεν υπάρχει σύνδεση στο internet',
      reload: 'Επαναφόρτωση',
      error_not_open_table: 'Πρέπει να βρίσκεστε στο τραπέζι για να παραγγείλετε. Επιστρέψτε στο τραπέζι και σαρώστε ξανά.',
      error_not_open_table_1: 'Ο σύνδεσμός σας δεν είναι έγκυρος. Επιστρέψτε στο τραπέζι και σαρώστε ξανά τον κωδικό QR.',
      error_not_open_table_2: 'Η υπηρεσία "Παραγγελία στο τραπέζι" δεν είναι διαθέσιμη. Ρωτήστε το προσωπικό.',
      error_not_open_table_3: 'Η υπηρεσία "Παραγγελία στο τραπέζι" δεν είναι διαθέσιμη. Ρωτήστε το προσωπικό.',
      error_not_open_table_4: 'Η υπηρεσία "Παραγγελία στο τραπέζι" δεν είναι διαθέσιμη. Ρωτήστε το προσωπικό.',
      error_not_open_table_5: 'Η υπηρεσία "Παραγγελία στο τραπέζι" δεν είναι διαθέσιμη. Ρωτήστε το προσωπικό.',
      error_not_open_table_6: 'Η υπηρεσία "Παραγγελία στο τραπέζι" δεν είναι διαθέσιμη. Ρωτήστε το προσωπικό.',
      error_not_open_table_7: 'Ο σύνδεσμός σας δεν είναι έγκυρος. Επιστρέψτε στο τραπέζι και σαρώστε ξανά τον κωδικό QR.',
      error_not_open_table_8: 'Το κατάστημα είναι εκτός ωραρίου λειτουργίας. Περιμένετε μέχρι να ανοίξει.',
      error: 'Σφάλμα',
      errProductLoad: 'Το προϊόν δεν ήταν δυνατό να φορτωθεί',
      errProductsLoad: 'Τα προϊόντα δεν ήταν δυνατό να φορτωθούν',
      errOrderMethod: 'Δεν ήταν δυνατή η αποθήκευση της επιλογής σας. Δοκιμάστε ξανά.',
      errPaymentProfileLoad: 'Δεν ήταν δυνατή η φόρτωση των τρόπων πληρωμής',
      loyaltyPoints: 'Πόντοι επιβράβευσης:',
      loyaltyPointsText: 'Σύνολο πόντων επιβράβευσης',
      applyLoyalty: 'Χρήση πόντων',
      removeLoyalty: 'Αφαίρεση πόντων',
      walletTotalText: 'Σύνολο στο πορτοφόλι',
      applyWallet: 'Πληρωμή από το πορτοφόλι',
      removeWallet: 'Αφαίρεση χρημάτων του πορτοφολιού από την παραγγελία',
      walletAppNot1: 'Αναμονή έγκρισης από την εφαρμογή...',
      walletAppNot2: 'Αν δεν λάβατε την ειδοποίηση ή οι ειδοποιήσεις δεν είναι ενεργοποιημένες στην εφαρμογή, μεταβείτε στον λογαριασμό σας και πατήστε την επιλογή ελέγχου ταυτότητας δύο παραγόντων.',
      walletAppNotErr1: 'Σφάλμα αποστολής κωδικού',
      walletAppNotErr2: 'Σφάλμα επαλήθευσης 2FA',
      walletAppNotErr3: 'Το αίτημα απορρίφθηκε',
      selectWalletValue: 'Επιλέξτε το ποσό που θέλετε να χρησιμοποιήσετε',
      selectWalletValueErr: 'Έχετε μόνο ',
      selectWalletValueErr2: 'Έχετε προϊόντα στο καλάθι σας αξίας ',
      walletPay: 'Πληρωμή από το πορτοφόλι:',
    },
    addOrder: {
      'pleaseWait': 'Παρακαλώ περιμένετε',
      'pleaseWaitFiscalReceipt': 'Παρακαλώ περιμένετε την ταμειακή απόδειξη',
      'selectTip': 'Επιλογή φιλοδωρήματος',
      'customTip': 'Προσαρμοσμένο ποσό',
      'enterCustomTip': 'Εισαγάγετε προσαρμοσμένο φιλοδώρημα',
      'tipAdded': 'Το φιλοδώρημα προστέθηκε',
      'removeTip': 'Αφαίρεση φιλοδωρήματος',
      'outOfStock': 'Εξαντλήθηκε',
      'available': 'διαθέσιμο',
      'sufficientStock': 'Επαρκές απόθεμα',
      'productNoStock': 'Το προϊόν έχει εξαντληθεί',
      'unavailable': 'Μη διαθέσιμο',
      'productUnavailable': 'Το προϊόν δεν είναι διαθέσιμο αυτή τη στιγμή',
      'addPager': 'Εισαγάγετε έναν βομβητή πριν από την πληρωμή',
      'vivaPaySuccess': 'Ευχαριστούμε, η πληρωμή ολοκληρώθηκε με επιτυχία!',
      'cart_lost': 'Εντοπίστηκε άλλο κιόσκι.',
      'cart_lost_title': 'Παρουσιάστηκε πρόβλημα',
      'err1': 'Επιλέξτε τα προϊόντα που θέλετε να πληρώσετε!',
      'askcashtxt': 'Σε λίγα λεπτά θα έρθει ένας σερβιτόρος για να παραλάβει την πληρωμή σας',
      'waiter_called': 'Ο σερβιτόρος ειδοποιήθηκε και θα έρθει σύντομα',
      'back': 'Πίσω',
      'titlePopupEditFgpName': 'Πώς σας λένε;',
      'addPopupEditFgpName': 'Αποθήκευση',
      'askFirstNameTitle': 'Ποιο είναι το όνομά σας;',
      'askFirstNameRequired': 'Παρακαλώ εισάγετε το όνομά σας',
      'waitingOpenOrder': 'Η παραγγελία σας ετοιμάζεται και θα είναι έτοιμη σε λίγα λεπτά.',
      'close': 'Κλείσιμο',
      'allSelect': 'Επιλογή όλων',
      'inProcesing': 'Σε επεξεργασία',
      'inPrepared': 'Έτοιμο',
      'deselectAll': 'Κατάργηση επιλογής όλων',
      'openOrder': 'Υποβολή παραγγελίας',
      'openOrderNotAvailable': 'Δεν έχουν αποσταλεί όλα τα προϊόντα',
      'productNavbar': 'Προϊόν',
      'menuNavbar': 'Μενού',
      'payNavbar': 'Πληρωμή',
      'optionNavar': 'Επιλογές',
      'chooseLanguage': 'Επιλέξτε τη γλώσσα σας',
      'tip': 'Φιλοδωρήματα',
      'tipsValue': 'Εισαγάγετε ποσό:',
      'splashScreenOrderNow': 'Παραγγελία τώρα',
      'ordersHistory': 'Προβολή ιστορικού παραγγελιών:',
      'orderNew': 'Νέα παραγγελία',
      'addToCart': 'Το προϊόν προστέθηκε στο καλάθι',
      'order_id_freeze': 'Η πληρωμή ξεκίνησε. Συνεχίστε με την πληρωμή ή περιμένετε να λήξει ο σύνδεσμος πληρωμής για να τροποποιήσετε την παραγγελία.',
      'euPlatesc_error1': 'Η ταυτοποίηση απέτυχε',
      'euPaysc_error2': 'Ανεπαρκές υπόλοιπο',
      'euPaycesc_error3': 'Η συναλλαγή απέτυχε',
      'euPaycesc_error4': 'Η κάρτα έχει λήξει',
      'euPlatesc_error5': 'Μη έγκυρη απόκριση',
      'noProductsMessage': 'Αυτή τη στιγμή δεν υπάρχουν διαθέσιμα προϊόντα σε αυτή την κατηγορία.',
      'relogin': 'Υπάρχει κάποιος άλλος στο τραπέζι; Αν όχι, διαγράψτε την προηγούμενη παραγγελία.',
      'deleteOrder': 'Διαγραφή',
      'couninueOrder': 'Συνέχεια',
      'errorRelogin': 'Υπάρχει ανοιχτή παραγγελία. Ζητήστε από τον σερβιτόρο να την κλείσει.',
      'finishOrderMsg': 'Η παραγγελία σας υποβλήθηκε με επιτυχία! Παραμείνετε στο τραπέζι, εμείς θα φροντίσουμε για όλα.',
      'errorFinishOrderMsg': 'Η πληρωμή απέτυχε! Ελέγξτε τα στοιχεία πληρωμής. Δοκιμάστε ξανά ή ζητήστε βοήθεια από τον σερβιτόρο.',
      'payByCard': 'Πληρωμή με κάρτα',
      'payByCashMachine': 'Τοποθετήστε τα χαρτονομίσματα στο μηχάνημα',
      'payByCashMachineDone': 'Περιμένετε!',
      'howPay': 'Πώς θέλετε να πληρώσετε;',
      'posGeneralError': 'Η συναλλαγή απέτυχε!',
      'selectMinMax': 'Μπορείτε να επιλέξετε',
      'selectMin': ' τουλάχιστον',
      'selectMax': ' το πολύ',
      'cartBtn': 'Το καλάθι μου',
      'emptyCartBtn': 'Άδειασμα καλαθιού',
      'splashScreenWrapperStart': 'Αγγίξτε την οθόνη για να ξεκινήσετε μια παραγγελία',
      'swipeUpTooltip': 'Σύρετε για να μεταβείτε στην επόμενη κατηγορία',
      'resetQuestion': 'Θέλετε να ξεκινήσετε από την αρχή;',
      'emptyCart': 'Θέλετε να διαγράψετε όλα τα προϊόντα από το καλάθι;',
      'emptyCartProduct': 'Θέλετε να διαγράψετε το προϊόν από το καλάθι;',
      'yes': 'Ναι',
      'no': 'Όχι',
      'jumpOver': 'Παράλειψη',
      'soldWithAdd': 'Προσθήκη',
      'soldWithNo': 'Όχι, ευχαριστώ',
      'soldWithExtra': 'Σύνολο πρόσθετων',
      'placeholderWaiter': '(π.χ. απόδειξη πληρωμής)',
      'sendWaiterValidate': 'Πρέπει να εισαγάγετε έναν λόγο!',
      'sendWaiter': 'Θέλετε να καλέσετε τον σερβιτόρο;',
      'soldWithTitle': 'Πρόταση',
      'menuCombo': 'Θέλετε να επιλέξετε το γεύμα σε μενού;',
      'couponExit': 'Αγγίξτε οπουδήποτε για έξοδο',
      'couponTitle': 'Εισαγάγετε τον κωδικό κουπονιού',
      'enterCui': 'Εισαγάγετε το CUI',
      'noProductsFound': 'Δεν βρέθηκαν τα προϊόντα που αναζητήσατε.',
      'couponPlaceholder': 'Πληκτρολογήστε τον κωδικό κουπονιού',
      'pagerTitle': 'Σαρώστε τον κωδικό QR στον βομβητή',
      'pagerPlaceholder': 'Κωδικός βομβητή',
      'pagerBtn': 'Προσθήκη βομβητή',
      'couponBtn': 'Εφαρμογή κουπονιού:',
      'commentBtn': 'Πρόσθετες πληροφορίες:',
      'couponButton': 'Εφαρμογή',
      'couponBtn2': 'Έχετε κωδικό προσφοράς;',
      'orderNumber': 'Αριθμός παραγγελίας',
      'step1': 'Περιμένετε να εμφανιστεί ο αριθμός της παραγγελίας σας στην οθόνη',
      'step2': 'Παραλάβετε την παραγγελία σας από το ταμείο',
      'yourOrderNr': 'Αριθμός παραγγελίας',
      'doneShortly': 'Η παραγγελία σας ετοιμάζεται.',
      'thenks': 'Ευχαριστούμε!',
      'qrStep1': 'Βήμα 1: Σαρώστε τον κωδικό QR με την κάμερα του κινητού σας.',
      'qrStep2': 'Βήμα 2: Ανοίξτε τον σύνδεσμο, συμπληρώστε τα πεδία (αριθμός κάρτας, email) και επιλέξτε τα πλαίσια. Προσοχή! Η αποδοχή των όρων και προϋποθέσεων είναι υποχρεωτική, διαφορετικά η πληρωμή δεν μπορεί να πραγματοποιηθεί.',
      'qrStep3': 'Βήμα 3: Πατήστε το κουμπί Πληρωμή online',
      'qrStep4': 'Βήμα 4: Σε λίγα δευτερόλεπτα θα λάβετε την επιβεβαίωση πληρωμής.',
      'qrCancel': 'Ακύρωση',
      'qrText': 'Έχετε ',
      'qrText2': 'δευτερόλεπτα για να πληρώσετε την παραγγελία, διαφορετικά θα ακυρωθεί',
      'backShopping': 'Επιστροφή στο μενού',
      'qr': 'Online με σάρωση του κωδικού QR',
      'cash_waiter': 'Μετρητά στον σερβιτόρο',
      'cash_bar': 'Μετρητά στο μπαρ',
      'pos_waiter': 'POS στον σερβιτόρο',
      'pos_bar': 'ΚΑΡΤΑ/POS στο μπαρ',
      'card': 'Online πληρωμή',
      'counter': 'Στο ταμείο',
      'counter_cash': 'Μετρητά στο ταμείο',
      'counter_pos': 'POS στο ταμείο',
      'pack': 'Πού θα φάτε σήμερα;',
      'takeAway': 'Για έξω',
      'takeAway_first': 'Για',
      'takeAway_second': 'έξω',
      'dineIn': 'Φαγητό εδώ',
      'dineIn_first': 'Φαγητό',
      'dineIn_second': 'εδώ',
      'paymentOptions': 'Επιλογές πληρωμής',
      'posOffline': 'Το τερματικό κάρτας είναι αποσυνδεδεμένο',
      'posRetry': 'Επανάληψη',
      'weitingForAddToCartToFinish': 'Υπολογίζεται το σύνολο',
      'empty': 'Το καλάθι σας είναι άδειο',
      'backToMenu': 'Επιστροφή στο μενού',
      'total': 'Σύνολο:',
      'search': 'Αναζήτηση',
      'titleClient': 'Πελάτης',
      'titleMethod': 'Τρόπος παράδοσης',
      'titleLocation': 'Τοποθεσία',
      'titleAdress': 'Διεύθυνση παράδοσης',
      'titleStatus': 'Κατάσταση',
      'done': 'Έτοιμο',
      'datepicker': 'Επιλέξτε ημερομηνία',
      'hourpicker': 'Επιλέξτε ώρα',
      'how_many': 'Για πόσα άτομα γίνεται η κράτηση',
      'tags': 'Παραγγελία από',
      'titlePopupTip': 'Προσθήκη ποσού',
      'btnPopup': 'Προσθήκη',
      'titlePopupCoupon': 'Προσθήκη κουπονιού',
      'errorPopupCoupon': 'Λανθασμένο κουπόνι',
      'errorProduct1': 'Τα προϊόντα δεν είναι πλέον διαθέσιμα και αφαιρέθηκαν από το καλάθι',
      'errorProduct2': 'Ένα ή περισσότερα προϊόντα δεν είναι πλέον διαθέσιμα και αφαιρέθηκαν από το καλάθι',
      'errorProduct3': 'Πρέπει να έχετε προϊόντα στο καλάθι για να μπορέσετε να παραγγείλετε!',
      'errorProduct4': 'Επιλέξτε τρόπο και τοποθεσία',
      'errorProduct5': 'Προσθέστε έναν πελάτη',
      'errorProduct6': 'Δεν έχει επιλεγεί τρόπος πληρωμής',
      'errorProduct7': 'Προσθέστε μια διεύθυνση',
      'add': 'Προσθήκη',
      'addFor': 'Προσθήκη για ',
      'edit': 'Επεξεργασία',
      'next_to_option': 'Προσθήκη',
      'prev_to_option': 'Προηγούμενο',
      'infosup': 'Προσθήκη επιπλέον πληροφοριών',
      'guest': 'Επισκέπτης',
      'newScan': 'Για να ξεκινήσετε νέα παραγγελία, σαρώστε ξανά.',
      'state': 'Νομός',
      'city': 'Πόλη',
      'adress': 'Κτίριο, σκάλα, όροφος, διαμέρισμα',
      'number': 'Αριθμός',
      'street': 'Οδός',
      'adressname': 'Όνομα διεύθυνσης',
      'sexf': 'Γυναίκα',
      'sexm': 'Άνδρας',
      'sex': 'Φύλο',
      'birthdate': 'Ημερομηνία γέννησης',
      'contactperson': 'Υπεύθυνος επικοινωνίας',
      'newclient': 'Προσθήκη ή επιλογή πελάτη',
      'newadress': 'Προσθήκη ή επιλογή διεύθυνσης',
      'save1': 'Επιλέξτε και αποθηκεύστε τις αλλαγές',
      'deliveryAdress': 'Προσθήκη διεύθυνσης',
      'deliveryAdressEdit': 'Επεξεργασία διεύθυνσης',
      'firstName': 'Όνομα',
      'lastName': 'Επώνυμο',
      'contactPers': 'Υπεύθυνος επικοινωνίας',
      'clientSelected': 'Επιλεγμένος πελάτης',
      'clearFields': 'Εκκαθάριση πεδίων',
      'addAdress': '+ Προσθήκη διεύθυνσης',
      'existingClient': 'Παραγγελία από',
      'orderNow': 'Πληρωμή',
      'orderNowDesc': '⚠️ Πληρώστε μόνο ακριβώς πριν φύγετε. Μέχρι τότε, μπορείτε να συνεχίσετε να παραγγέλνετε άλλα προϊόντα από το μενού.',
      'viva_walet': 'Με κάρτα στη συσκευή',
      'vivaWaitingText': 'Αναμονή για το άνοιγμα της εφαρμογής Viva...',
      'vivaRetryButton': 'Επανάληψη',
      'vivaCancelButton': 'Ακύρωση',
      'pos': 'Με κάρτα',
      'cash': 'Μετρητά',
      'free': 'Δωρεάν',
      'coment': 'Σχόλιο παραγγελίας',
      'addTip': 'Προσθήκη φιλοδωρήματος:',
      'addTipValue': 'Εισαγάγετε το ποσό',
      'addTipButton': 'Προσθήκη',
      'removeTip': 'Αφαίρεση φιλοδωρήματος',
      'removeTipButton': 'Αφαίρεση',
      'addCoupon': 'Προσθήκη εκπτωτικού κουπονιού',
      'removeCoupon': 'Διαγραφή κουπονιού',
      'removeCouponButton': 'Διαγραφή',
      'modif': 'Επεξεργασία',
      'delete': 'Διαγραφή',
      'freeProd': 'Δωρεάν προϊόν',
      'info': 'Πληροφορίες',
      'orderDet': 'Λεπτομέρειες παραγγελίας',
      'cartDet': 'Το καλάθι μου',
      'fast': 'Το συντομότερο δυνατό',
      'selectHour': 'Επιλέξτε ώρα',
      'selectPayment': 'Επιλέξτε τρόπο πληρωμής',
      'pleaseSelectMethodAndLoc': 'Επιλέξτε τρόπο και τοποθεσία!',
      'locSelect': 'Επιλέξτε τοποθεσία',
      'searchProduct': 'αναζήτηση προϊόντων',
      'phone': 'Τηλέφωνο',
      'email': 'Email',
      'inlocation': 'Στο κατάστημα',
      'cuiPlaceholder': 'Εισαγάγετε ΑΦΜ',
      'emailFieldsTitle1': 'Βοηθήστε μας να βελτιώσουμε την εμπειρία',
      'emailFieldsTitle2': 'Αφήστε μας ένα email για να σας στείλουμε την επιβεβαίωση της παραγγελίας!',
      'emailPlaceholder': 'Διεύθυνση email',
      'phonePlaceholder': 'Αριθμός τηλεφώνου',
      'phoneFieldsTitle1': 'Εισαγάγετε τον αριθμό τηλεφώνου:',
      'phoneSearch': 'Προσθήκη',
      'client': 'Πελάτης:',
      'newClient': 'Νέος πελάτης:',
      'phoneFidelityTitle': 'Φόρτωση πόντων επιβράβευσης;',
      'phoneFieldsTitle2': 'Ή σαρώστε τον κωδικό QR από την εφαρμογή',
      'phoneError': 'Μη έγκυρος αριθμός τηλεφώνου',
      'qrError': 'Μη έγκυρος κωδικός QR. Σαρώστε ξανά ή εισαγάγετε τον αριθμό τηλεφώνου!',
      'emailError': 'Μη έγκυρο email',
      'adressNotInRange': 'Η διεύθυνση είναι εκτός εμβέλειας. Αλλάξτε τη διεύθυνση!',
      'adressNotCorect': 'Η διεύθυνση δεν είναι σωστή',
      'continueToPay': 'Συνέχεια στην πληρωμή',
      'loyalityNoSms': 'Θέλετε πόντους επιβράβευσης;',
      'noLoyalitySms': 'Θέλετε να μάθετε πότε θα είναι έτοιμη η παραγγελία;',
      'loyalitySms': 'Θέλετε να μάθετε πότε θα είναι έτοιμη η παραγγελία σας και να κερδίσετε πόντους επιβράβευσης;',
      'new_client_fidelity': 'Αφού δημιουργήσετε λογαριασμό στην εφαρμογή με αυτόν τον αριθμό τηλεφώνου, οι πόντοι επιβράβευσης θα αποδοθούν αυτόματα σε αυτόν τον λογαριασμό.',
      'cardDesc1': 'Επεξεργασία πληρωμής με κάρτα',
      'cardDesc2': 'Περιμένετε λίγα λεπτά μέχρι να ολοκληρωθεί η επεξεργασία της συναλλαγής σας',
      'cardDesc3': 'Ευχαριστούμε για την υπομονή σας!'
    }
  },
  it: {
    general: {
      tip: 'Mancia',
      confirm: 'Conferma',
      search: 'Cerca',
      add: 'Aggiungi',
      edit: 'Modifica',
      delete: 'Elimina',
      remove: 'Rimuovi',
      save: 'Salva',
      update: 'Aggiorna',
      cancel: 'Annulla',
      cancel2: 'Annulla',
      continue: 'Continua',
      activate: 'attiva',
      deactivate: 'disattiva',
      active: 'attivo',
      inactive: 'inattivo',
      specialPrice: 'Prezzo speciale',
      removePhoto: 'Sono state caricate troppe immagini',
      yes: 'Sì',
      no: 'No',
      success: 'Successo',
      required: 'obbligatorio',
      back: 'indietro',
      next: 'Avanti',
      finish: 'Completa',
      duplicate: 'Duplica',
      select: 'Seleziona',
      all: 'Tutto',
      alls: 'Tutti',
      reset: 'Reimposta',
      export: 'Esporta',
      loadMore: 'Carica altro',
      viewDetails: 'Visualizza dettagli',
      showing: 'Visualizzazione di {length} risultato/i',
      enable: 'attiva',
      disable: 'disattiva',
      product: 'prodotto',
      logout: 'Esci',
      from: 'da',
      to: 'a',
      cancelCourier: 'Annulla corriere',
      agree: 'Accetto',
      agreePopupMessage: 'Per consentire al browser di riprodurre audio, devi fare clic su "Accetto". Verrà riprodotto un suono di prova per attivare la riproduzione audio.',
      day: 'giorno',
      notCompleted: 'non completato',
      saveChanges: 'Salva modifiche',
      doYouWantToLogout: 'Vuoi uscire?',
      minutes: 'minuti',
      hour: 'ora',
      hours: 'ore',
      customSort: "L'azienda utilizza un ordinamento personalizzato",
      deliveryMethod: 'Modalità di consegna',
      none: 'Nessuno',
      included: 'Incluso',
      error_fiscal_kiosk: 'Errore del registratore di cassa, chiama un dipendente',
      error_not_open_kiosk: 'È chiuso!',
      no_internet_kiosk: 'Nessuna connessione a internet',
      reload: 'Ricarica',
      error_not_open_table: 'Devi trovarti al tavolo per ordinare. Torna al tavolo ed esegui di nuovo la scansione.',
      error_not_open_table_1: 'Il tuo link non è valido. Torna al tavolo e scansiona nuovamente il codice QR.',
      error_not_open_table_2: 'Il servizio "Ordina al tavolo" non è disponibile. Chiedi al personale.',
      error_not_open_table_3: 'Il servizio "Ordina al tavolo" non è disponibile. Chiedi al personale.',
      error_not_open_table_4: 'Il servizio "Ordina al tavolo" non è disponibile. Chiedi al personale.',
      error_not_open_table_5: 'Il servizio "Ordina al tavolo" non è disponibile. Chiedi al personale.',
      error_not_open_table_6: 'Il servizio "Ordina al tavolo" non è disponibile. Chiedi al personale.',
      error_not_open_table_7: 'Il tuo link non è valido. Torna al tavolo e scansiona nuovamente il codice QR.',
      error_not_open_table_8: "Il locale è fuori dall'orario di apertura. Attendi l'apertura.",
      error: 'Errore',
      errProductLoad: 'Impossibile caricare il prodotto',
      errProductsLoad: 'Impossibile caricare i prodotti',
      errOrderMethod: 'Impossibile salvare la scelta di consumo. Riprova.',
      errPaymentProfileLoad: 'Impossibile caricare i metodi di pagamento',
      loyaltyPoints: 'Punti fedeltà:',
      loyaltyPointsText: 'Totale punti fedeltà',
      applyLoyalty: 'Applica punti',
      removeLoyalty: 'Rimuovi punti',
      walletTotalText: 'Totale nel portafoglio',
      applyWallet: 'Paga dal portafoglio',
      removeWallet: "Rimuovi dall'ordine il denaro del portafoglio",
      walletAppNot1: "In attesa dell'approvazione dall'app...",
      walletAppNot2: "Se non hai ricevuto la notifica o le notifiche non sono abilitate nell'app, vai al tuo account e tocca l'opzione di autenticazione a due fattori.",
      walletAppNotErr1: "Errore durante l'invio del codice",
      walletAppNotErr2: 'Errore di verifica 2FA',
      walletAppNotErr3: 'La richiesta è stata rifiutata',
      selectWalletValue: "Seleziona l'importo che vuoi utilizzare",
      selectWalletValueErr: 'Hai soltanto ',
      selectWalletValueErr2: 'Hai prodotti nel carrello per un valore di ',
      walletPay: 'Paga dal portafoglio:',
    },
    addOrder: {
      'pleaseWait': 'Attendere prego',
      'pleaseWaitFiscalReceipt': 'Attendere lo scontrino fiscale',
      'selectTip': 'Seleziona la mancia',
      'customTip': 'Importo personalizzato',
      'enterCustomTip': 'Inserisci una mancia personalizzata',
      'tipAdded': 'Mancia aggiunta',
      'removeTip': 'Rimuovi la mancia',
      'outOfStock': 'Esaurito',
      'available': 'disponibile',
      'sufficientStock': 'Disponibilità sufficiente',
      'productNoStock': 'Il prodotto è esaurito',
      'unavailable': 'Non disponibile',
      'productUnavailable': 'Il prodotto non è al momento disponibile',
      'addPager': 'Inserisci un cercapersone prima del pagamento',
      'vivaPaySuccess': 'Grazie, il pagamento è stato effettuato con successo!',
      'cart_lost': 'È stato rilevato un altro chiosco.',
      'cart_lost_title': 'Si è verificato un problema',
      'err1': 'Seleziona i prodotti che vuoi pagare!',
      'askcashtxt': 'Tra pochi istanti un cameriere verrà a ritirare il pagamento',
      'waiter_called': 'Il cameriere è stato avvisato e arriverà a breve',
      'back': 'Indietro',
      'titlePopupEditFgpName': 'Come ti chiami?',
      'addPopupEditFgpName': 'Salva',
      'askFirstNameTitle': 'Qual è il tuo nome?',
      'askFirstNameRequired': 'Inserisci il tuo nome',
      'waitingOpenOrder': 'Il tuo ordine è in preparazione e sarà pronto tra pochi istanti.',
      'close': 'Chiudi',
      'allSelect': 'Seleziona tutto',
      'inProcesing': 'In elaborazione',
      'inPrepared': 'Pronto',
      'deselectAll': 'Deseleziona tutto',
      'openOrder': "Effettua l'ordine",
      'openOrderNotAvailable': 'Non tutti i prodotti sono stati inviati',
      'productNavbar': 'Prodotto',
      'menuNavbar': 'Menu',
      'payNavbar': 'Paga',
      'optionNavar': 'Opzioni',
      'chooseLanguage': 'Scegli la tua lingua',
      'tip': 'Mance',
      'tipsValue': "Inserisci l'importo:",
      'splashScreenOrderNow': 'Ordina ora',
      'ordersHistory': 'Visualizza cronologia ordini:',
      'orderNew': 'Nuovo ordine',
      'addToCart': 'Il prodotto è stato aggiunto al carrello',
      'order_id_freeze': "Il pagamento è stato avviato. Procedi con il pagamento oppure attendi la scadenza del link di pagamento per modificare l'ordine.",
      'euPlatesc_error1': 'Autenticazione non riuscita',
      'euPaysc_error2': 'Fondi insufficienti',
      'euPaycesc_error3': 'Transazione non riuscita',
      'euPaycesc_error4': 'Carta scaduta',
      'euPlatesc_error5': 'Risposta non valida',
      'noProductsMessage': 'Al momento non ci sono prodotti disponibili in questa categoria.',
      'relogin': "C'è qualcun altro al tavolo? In caso contrario, elimina l'ordine precedente.",
      'deleteOrder': 'Elimina',
      'couninueOrder': 'Continua',
      'errorRelogin': "C'è un ordine aperto. Chiedi al cameriere di chiuderlo.",
      'finishOrderMsg': "Il tuo ordine è stato effettuato con successo! Rimani al tavolo, ci occuperemo noi di tutto.",
      'errorFinishOrderMsg': 'Pagamento non riuscito! Controlla i dati inseriti per il pagamento. Riprova o chiedi al cameriere.',
      'payByCard': 'Paga con carta',
      'payByCashMachine': 'Inserisci le banconote nella macchina',
      'payByCashMachineDone': 'Attendi!',
      'howPay': 'Come vuoi pagare?',
      'posGeneralError': 'Transazione non riuscita!',
      'selectMinMax': 'Puoi selezionare',
      'selectMin': ' almeno',
      'selectMax': ' al massimo',
      'cartBtn': 'Il mio carrello',
      'emptyCartBtn': 'Svuota carrello',
      'splashScreenWrapperStart': 'Tocca lo schermo per iniziare un ordine',
      'swipeUpTooltip': 'Scorri per passare alla categoria successiva',
      'resetQuestion': "Vuoi ricominciare dall'inizio?",
      'emptyCart': 'Vuoi eliminare tutti i prodotti dal carrello?',
      'emptyCartProduct': 'Vuoi eliminare il prodotto dal carrello?',
      'yes': 'Sì',
      'no': 'No',
      'jumpOver': 'Salta',
      'soldWithAdd': 'Aggiungi',
      'soldWithNo': 'No, grazie',
      'soldWithExtra': 'Totale extra',
      'placeholderWaiter': '(ad es. ricevuta di pagamento)',
      'sendWaiterValidate': 'Devi inserire un motivo!',
      'sendWaiter': 'Vuoi chiamare il cameriere?',
      'soldWithTitle': 'Consiglio',
      'menuCombo': "Vuoi scegliere l'opzione menu?",
      'couponExit': 'Tocca un punto qualsiasi per uscire',
      'couponTitle': 'Inserisci il codice coupon',
      'enterCui': 'Inserisci il CUI',
      'noProductsFound': 'I prodotti cercati non sono stati trovati.',
      'couponPlaceholder': 'Digita il codice coupon',
      'pagerTitle': 'Scansiona il codice QR sul cercapersone',
      'pagerPlaceholder': 'Codice cercapersone',
      'pagerBtn': 'Aggiungi cercapersone',
      'couponBtn': 'Applica coupon:',
      'commentBtn': 'Informazioni aggiuntive:',
      'couponButton': 'Applica',
      'couponBtn2': 'Hai un codice promozionale?',
      'orderNumber': "Numero dell'ordine",
      'step1': "Attendi che il numero dell'ordine venga visualizzato sullo schermo",
      'step2': "Ritira l'ordine alla cassa",
      'yourOrderNr': "Numero dell'ordine",
      'doneShortly': 'Il tuo ordine è in preparazione.',
      'thenks': 'Grazie!',
      'qrStep1': 'Passaggio 1: Scansiona il codice QR con la fotocamera dello smartphone.',
      'qrStep2': 'Passaggio 2: Apri il link, compila i campi (numero della carta, email) e seleziona le caselle. Attenzione! È obbligatorio accettare i termini e le condizioni, altrimenti non sarà possibile effettuare il pagamento.',
      'qrStep3': 'Passaggio 3: Fai clic sul pulsante Paga online',
      'qrStep4': 'Passaggio 4: Tra pochi secondi riceverai la conferma del pagamento.',
      'qrCancel': 'Annulla',
      'qrText': 'Hai ',
      'qrText2': "secondi per pagare l'ordine, altrimenti verrà annullato",
      'backShopping': 'Torna al menu',
      'qr': 'Online scansionando il codice QR',
      'cash_waiter': 'Contanti al cameriere',
      'cash_bar': 'Contanti al bar',
      'pos_waiter': 'POS al cameriere',
      'pos_bar': 'CARTA/POS al bar',
      'card': 'Pagamento online',
      'counter': 'Alla cassa',
      'counter_cash': 'Contanti alla cassa',
      'counter_pos': 'POS alla cassa',
      'pack': 'Dove mangerai oggi?',
      'takeAway': 'Da asporto',
      'takeAway_first': 'Da',
      'takeAway_second': 'asporto',
      'dineIn': 'Mangia qui',
      'dineIn_first': 'Mangia',
      'dineIn_second': 'qui',
      'paymentOptions': 'Opzioni di pagamento',
      'posOffline': 'Il terminale di pagamento è disconnesso',
      'posRetry': 'Riprova',
      'weitingForAddToCartToFinish': 'Calcolo del totale in corso',
      'empty': 'Il tuo carrello è vuoto',
      'backToMenu': 'Torna al menu',
      'total': 'Totale:',
      'search': 'Cerca',
      'titleClient': 'Cliente',
      'titleMethod': 'Modalità di consegna',
      'titleLocation': 'Sede',
      'titleAdress': 'Indirizzo di consegna',
      'titleStatus': 'Stato',
      'done': 'Fatto',
      'datepicker': 'Seleziona una data',
      'hourpicker': "Seleziona un'ora",
      'how_many': 'Per quante persone è la prenotazione',
      'tags': 'Ordina da',
      'titlePopupTip': 'Aggiungi importo',
      'btnPopup': 'Aggiungi',
      'titlePopupCoupon': 'Aggiungi coupon',
      'errorPopupCoupon': 'Coupon errato',
      'errorProduct1': 'I prodotti non sono più disponibili e sono stati eliminati dal carrello',
      'errorProduct2': 'Uno o più prodotti non sono più disponibili e sono stati eliminati dal carrello',
      'errorProduct3': 'Devi avere prodotti nel carrello per poter ordinare!',
      'errorProduct4': 'Seleziona la modalità e la sede',
      'errorProduct5': 'Aggiungi un cliente',
      'errorProduct6': 'Modalità di pagamento non selezionata',
      'errorProduct7': 'Aggiungi un indirizzo',
      'add': 'Aggiungi',
      'addFor': 'Aggiungi per ',
      'edit': 'Modifica',
      'next_to_option': 'Aggiungi',
      'prev_to_option': 'Indietro',
      'infosup': 'Aggiungi informazioni',
      'guest': 'Ospite',
      'newScan': 'Per iniziare un nuovo ordine, esegui nuovamente la scansione.',
      'state': 'Provincia',
      'city': 'Città',
      'adress': 'Edificio, scala, piano, appartamento',
      'number': 'Numero',
      'street': 'Via',
      'adressname': "Nome dell'indirizzo",
      'sexf': 'Donna',
      'sexm': 'Uomo',
      'sex': 'Sesso',
      'birthdate': 'Data di nascita',
      'contactperson': 'Persona di contatto',
      'newclient': 'Aggiungi o scegli un cliente',
      'newadress': "Aggiungi o scegli l'indirizzo",
      'save1': 'Scegli e salva le modifiche',
      'deliveryAdress': 'Aggiungi indirizzo',
      'deliveryAdressEdit': 'Modifica indirizzo',
      'firstName': 'Nome',
      'lastName': 'Cognome',
      'contactPers': 'Persona di contatto',
      'clientSelected': 'Cliente selezionato',
      'clearFields': 'Cancella i campi',
      'addAdress': "+ Aggiungi l'indirizzo",
      'existingClient': 'Ordina da',
      'orderNow': 'Paga',
      'orderNowDesc': '⚠️ Paga soltanto subito prima di andare via. Fino a quel momento, puoi continuare a ordinare altri prodotti dal menu.',
      'viva_walet': 'Con carta sul dispositivo',
      'vivaWaitingText': 'In attesa dell\'apertura dell\'app Viva...',
      'vivaRetryButton': 'Riprova',
      'vivaCancelButton': 'Annulla',
      'pos': 'Con carta',
      'cash': 'Contanti',
      'free': 'Gratis',
      'coment': "Commento sull'ordine",
      'addTip': 'Aggiungi mancia:',
      'addTipValue': "Inserisci l'importo",
      'addTipButton': 'Aggiungi',
      'removeTip': 'Rimuovi mancia',
      'removeTipButton': 'Rimuovi',
      'addCoupon': 'Aggiungi coupon sconto',
      'removeCoupon': 'Elimina coupon',
      'removeCouponButton': 'Elimina',
      'modif': 'Modifica',
      'delete': 'Elimina',
      'freeProd': 'Prodotto gratuito',
      'info': 'Informazioni',
      'orderDet': "Dettagli dell'ordine",
      'cartDet': 'Il mio carrello',
      'fast': 'Il prima possibile',
      'selectHour': "Seleziona l'orario",
      'selectPayment': 'Seleziona la modalità di pagamento',
      'pleaseSelectMethodAndLoc': 'Seleziona la modalità e la sede!',
      'locSelect': 'Seleziona una sede',
      'searchProduct': 'cerca prodotti',
      'phone': 'Telefono',
      'email': 'Email',
      'inlocation': 'Nel locale',
      'cuiPlaceholder': 'Inserisci la partita IVA',
      'emailFieldsTitle1': "Aiutaci a migliorare l'esperienza",
      'emailFieldsTitle2': "Lasciaci un indirizzo email per inviarti la conferma dell'ordine!",
      'emailPlaceholder': 'Indirizzo email',
      'phonePlaceholder': 'Numero di telefono',
      'phoneFieldsTitle1': 'Inserisci il numero di telefono:',
      'phoneSearch': 'Aggiungi',
      'client': 'Cliente:',
      'newClient': 'Nuovo cliente:',
      'phoneFidelityTitle': 'Caricare i punti fedeltà?',
      'phoneFieldsTitle2': "Oppure scansiona il codice QR dall'applicazione",
      'phoneError': 'Numero di telefono non valido',
      'qrError': 'Codice QR non valido. Scansiona di nuovo o inserisci il numero di telefono!',
      'emailError': 'Email non valida',
      'adressNotInRange': "Fuori dall'area di consegna, modifica l'indirizzo!",
      'adressNotCorect': "L'indirizzo non è corretto",
      'continueToPay': 'Procedi al pagamento',
      'loyalityNoSms': 'Vuoi punti fedeltà?',
      'noLoyalitySms': "Vuoi sapere quando l'ordine sarà pronto?",
      'loyalitySms': 'Vuoi sapere quando il tuo ordine sarà pronto e ottenere punti fedeltà?',
      'new_client_fidelity': "Dopo aver creato un account nell'app con questo numero di telefono, i punti fedeltà verranno assegnati automaticamente all'account.",
      'cardDesc1': 'Elaborazione del pagamento con carta',
      'cardDesc2': 'Attendi qualche istante mentre la transazione viene elaborata',
      'cardDesc3': 'Grazie per la pazienza!'
    }
  },
  de: {
    general: {
      tip: 'Trinkgeld',
      confirm: 'Bestätigen',
      search: 'Suchen',
      add: 'Hinzufügen',
      edit: 'Bearbeiten',
      delete: 'Löschen',
      remove: 'Entfernen',
      save: 'Speichern',
      update: 'Aktualisieren',
      cancel: 'Abbrechen',
      cancel2: 'Abbrechen',
      continue: 'Weiter',
      activate: 'aktivieren',
      deactivate: 'deaktivieren',
      active: 'aktiv',
      inactive: 'inaktiv',
      specialPrice: 'Sonderpreis',
      removePhoto: 'Zu viele Bilder hochgeladen',
      yes: 'Ja',
      no: 'Nein',
      success: 'Erfolg',
      required: 'erforderlich',
      back: 'zurück',
      next: 'Weiter',
      finish: 'Abschließen',
      duplicate: 'Duplizieren',
      select: 'Auswählen',
      all: 'Alle',
      alls: 'Alle',
      reset: 'Zurücksetzen',
      export: 'Exportieren',
      loadMore: 'Mehr laden',
      viewDetails: 'Details anzeigen',
      showing: '{length} Ergebnis(se) werden angezeigt',
      enable: 'aktivieren',
      disable: 'deaktivieren',
      product: 'Produkt',
      logout: 'Abmelden',
      from: 'von',
      to: 'bis',
      cancelCourier: 'Kurier stornieren',
      agree: 'Zustimmen',
      agreePopupMessage: 'Damit der Browser Audio wiedergeben kann, müssen Sie auf "Zustimmen" klicken. Dadurch wird ein Testton abgespielt, um die Audiowiedergabe zu aktivieren.',
      day: 'Tag',
      notCompleted: 'nicht abgeschlossen',
      saveChanges: 'Änderungen speichern',
      doYouWantToLogout: 'Möchten Sie sich abmelden?',
      minutes: 'Minuten',
      hour: 'Stunde',
      hours: 'Stunden',
      customSort: 'Das Unternehmen verwendet eine benutzerdefinierte Sortierung',
      deliveryMethod: 'Liefermethoden',
      none: 'Keine',
      included: 'Inbegriffen',
      error_fiscal_kiosk: 'Fehler an der Registrierkasse, bitte rufen Sie einen Mitarbeiter',
      error_not_open_kiosk: 'Ist geschlossen!',
      no_internet_kiosk: 'Keine Internetverbindung',
      reload: 'Neu laden',
      error_not_open_table: 'Sie müssen sich am Tisch befinden, um zu bestellen. Gehen Sie zum Tisch zurück und scannen Sie erneut.',
      error_not_open_table_1: 'Ihr Link ist ungültig. Gehen Sie zum Tisch zurück und scannen Sie den QR-Code erneut.',
      error_not_open_table_2: 'Der Service "Bestellung am Tisch" ist nicht verfügbar. Bitte fragen Sie das Personal.',
      error_not_open_table_3: 'Der Service "Bestellung am Tisch" ist nicht verfügbar. Bitte fragen Sie das Personal.',
      error_not_open_table_4: 'Der Service "Bestellung am Tisch" ist nicht verfügbar. Bitte fragen Sie das Personal.',
      error_not_open_table_5: 'Der Service "Bestellung am Tisch" ist nicht verfügbar. Bitte fragen Sie das Personal.',
      error_not_open_table_6: 'Der Service "Bestellung am Tisch" ist nicht verfügbar. Bitte fragen Sie das Personal.',
      error_not_open_table_7: 'Ihr Link ist ungültig. Gehen Sie zum Tisch zurück und scannen Sie den QR-Code erneut.',
      error_not_open_table_8: 'Der Standort ist außerhalb der Öffnungszeiten geschlossen. Bitte warten Sie bis zur Öffnung.',
      error: 'Fehler',
      errProductLoad: 'Das Produkt konnte nicht geladen werden',
      errProductsLoad: 'Die Produkte konnten nicht geladen werden',
      errOrderMethod: 'Deine Auswahl konnte nicht gespeichert werden. Bitte versuche es erneut.',
      errPaymentProfileLoad: 'Zahlungsmethoden konnten nicht geladen werden',
      loyaltyPoints: 'Treuepunkte:',
      loyaltyPointsText: 'Treuepunkte insgesamt',
      applyLoyalty: 'Punkte anwenden',
      removeLoyalty: 'Punkte entfernen',
      walletTotalText: 'Gesamtguthaben in der Wallet',
      applyWallet: 'Aus der Wallet bezahlen',
      removeWallet: 'Wallet-Guthaben aus der Bestellung entfernen',
      walletAppNot1: 'Warten auf die Bestätigung in der App...',
      walletAppNot2: 'Wenn Sie keine Benachrichtigung erhalten haben oder Benachrichtigungen in der App nicht aktiviert sind, gehen Sie zu Ihrem Konto und tippen Sie auf die Option für die Zwei-Faktor-Authentifizierung.',
      walletAppNotErr1: 'Fehler beim Senden des Codes',
      walletAppNotErr2: 'Fehler bei der 2FA-Verifizierung',
      walletAppNotErr3: 'Die Anfrage wurde abgelehnt',
      selectWalletValue: 'Wählen Sie den Betrag aus, den Sie verwenden möchten',
      selectWalletValueErr: 'Sie haben nur ',
      selectWalletValueErr2: 'Der Wert der Produkte in Ihrem Warenkorb beträgt ',
      walletPay: 'Aus der Wallet bezahlen:',
    },
    addOrder: {
      'pleaseWait': 'Bitte warten',
      'pleaseWaitFiscalReceipt': 'Bitte warten Sie auf den Kassenbon',
      'selectTip': 'Trinkgeld auswählen',
      'customTip': 'Benutzerdefinierter Betrag',
      'enterCustomTip': 'Benutzerdefiniertes Trinkgeld eingeben',
      'tipAdded': 'Trinkgeld hinzugefügt',
      'removeTip': 'Trinkgeld entfernen',
      'outOfStock': 'Ausverkauft',
      'available': 'verfügbar',
      'sufficientStock': 'Ausreichend verfügbar',
      'productNoStock': 'Das Produkt ist nicht vorrätig',
      'unavailable': 'Nicht verfügbar',
      'productUnavailable': 'Das Produkt ist derzeit nicht verfügbar',
      'addPager': 'Bitte geben Sie vor der Zahlung einen Pager ein',
      'vivaPaySuccess': 'Vielen Dank, die Zahlung wurde erfolgreich durchgeführt!',
      'cart_lost': 'Ein weiterer Kiosk wurde erkannt.',
      'cart_lost_title': 'Ein Problem ist aufgetreten',
      'err1': 'Bitte wählen Sie die Produkte aus, die Sie bezahlen möchten!',
      'askcashtxt': 'In wenigen Augenblicken kommt eine Servicekraft, um Ihre Zahlung entgegenzunehmen',
      'waiter_called': 'Die Servicekraft wurde benachrichtigt und kommt in Kürze',
      'back': 'Zurück',
      'titlePopupEditFgpName': 'Wie heißen Sie?',
      'addPopupEditFgpName': 'Speichern',
      'askFirstNameTitle': 'Wie ist Ihr Vorname?',
      'askFirstNameRequired': 'Bitte geben Sie Ihren Vornamen ein',
      'waitingOpenOrder': 'Ihre Bestellung wird zubereitet und ist in wenigen Augenblicken fertig.',
      'close': 'Schließen',
      'allSelect': 'Alle auswählen',
      'inProcesing': 'In Bearbeitung',
      'inPrepared': 'Fertig',
      'deselectAll': 'Auswahl aufheben',
      'openOrder': 'Bestellung aufgeben',
      'openOrderNotAvailable': 'Nicht alle Produkte wurden gesendet',
      'productNavbar': 'Produkt',
      'menuNavbar': 'Menü',
      'payNavbar': 'Bezahlen',
      'optionNavar': 'Optionen',
      'chooseLanguage': 'Wählen Sie Ihre Sprache',
      'tip': 'Trinkgeld',
      'tipsValue': 'Betrag eingeben:',
      'splashScreenOrderNow': 'Jetzt bestellen',
      'ordersHistory': 'Bestellverlauf anzeigen:',
      'orderNew': 'Neue Bestellung',
      'addToCart': 'Das Produkt wurde zum Warenkorb hinzugefügt',
      'order_id_freeze': 'Die Zahlung wurde eingeleitet. Fahren Sie mit der Zahlung fort oder warten Sie, bis der Zahlungslink abgelaufen ist, um die Bestellung zu ändern.',
      'euPlatesc_error1': 'Authentifizierung fehlgeschlagen',
      'euPaysc_error2': 'Unzureichendes Guthaben',
      'euPaycesc_error3': 'Transaktion fehlgeschlagen',
      'euPaycesc_error4': 'Karte abgelaufen',
      'euPlatesc_error5': 'Ungültige Antwort',
      'noProductsMessage': 'Derzeit sind in dieser Kategorie keine Produkte verfügbar.',
      'relogin': 'Ist noch jemand am Tisch? Falls nicht, löschen Sie die vorherige Bestellung.',
      'deleteOrder': 'Löschen',
      'couninueOrder': 'Weiter',
      'errorRelogin': 'Es gibt eine offene Bestellung. Bitten Sie die Servicekraft, die Bestellung zu schließen.',
      'finishOrderMsg': 'Ihre Bestellung wurde erfolgreich aufgegeben! Bleiben Sie am Tisch, wir kümmern uns um alles.',
      'errorFinishOrderMsg': 'Die Zahlung ist fehlgeschlagen! Prüfen Sie die eingegebenen Zahlungsdaten. Versuchen Sie es erneut oder fragen Sie die Servicekraft.',
      'payByCard': 'Mit Karte bezahlen',
      'payByCashMachine': 'Stecken Sie die Banknoten in den Automaten',
      'payByCashMachineDone': 'Bitte warten!',
      'howPay': 'Wie möchten Sie bezahlen?',
      'posGeneralError': 'Transaktion fehlgeschlagen!',
      'selectMinMax': 'Sie können auswählen',
      'selectMin': ' mindestens',
      'selectMax': ' höchstens',
      'cartBtn': 'Mein Warenkorb',
      'emptyCartBtn': 'Warenkorb leeren',
      'splashScreenWrapperStart': 'Tippen Sie auf den Bildschirm, um eine Bestellung zu beginnen',
      'swipeUpTooltip': 'Wischen Sie zur nächsten Kategorie',
      'resetQuestion': 'Möchten Sie von vorne beginnen?',
      'emptyCart': 'Möchten Sie alle Produkte aus dem Warenkorb löschen?',
      'emptyCartProduct': 'Möchten Sie das Produkt aus dem Warenkorb löschen?',
      'yes': 'Ja',
      'no': 'Nein',
      'jumpOver': 'Überspringen',
      'soldWithAdd': 'Hinzufügen',
      'soldWithNo': 'Nein, danke',
      'soldWithExtra': 'Zusatzbetrag insgesamt',
      'placeholderWaiter': '(z. B. Zahlungsbeleg)',
      'sendWaiterValidate': 'Sie müssen einen Grund eingeben!',
      'sendWaiter': 'Möchten Sie die Servicekraft rufen?',
      'soldWithTitle': 'Empfehlung',
      'menuCombo': 'Möchten Sie die Menüoption wählen?',
      'couponExit': 'Tippen Sie zum Beenden auf eine beliebige Stelle',
      'couponTitle': 'Gutscheincode eingeben',
      'enterCui': 'CUI eingeben',
      'noProductsFound': 'Die gesuchten Produkte wurden nicht gefunden.',
      'couponPlaceholder': 'Gutscheincode eingeben',
      'pagerTitle': 'Scannen Sie den QR-Code auf dem Pager',
      'pagerPlaceholder': 'Pager-Code',
      'pagerBtn': 'Pager hinzufügen',
      'couponBtn': 'Gutschein anwenden:',
      'commentBtn': 'Zusätzliche Informationen:',
      'couponButton': 'Anwenden',
      'couponBtn2': 'Haben Sie einen Aktionscode?',
      'orderNumber': 'Bestellnummer',
      'step1': 'Warten Sie, bis Ihre Bestellnummer auf dem Bildschirm erscheint',
      'step2': 'Holen Sie Ihre Bestellung an der Kasse ab',
      'yourOrderNr': 'Bestellnummer',
      'doneShortly': 'Ihre Bestellung wird zubereitet.',
      'thenks': 'Vielen Dank!',
      'qrStep1': 'Schritt 1: Scannen Sie den QR-Code mit der Kamera Ihres Smartphones.',
      'qrStep2': 'Schritt 2: Öffnen Sie den Link, füllen Sie die Felder aus (Kartennummer, E-Mail) und aktivieren Sie die Kontrollkästchen. Achtung! Die Annahme der Geschäftsbedingungen ist verpflichtend, andernfalls kann die Zahlung nicht durchgeführt werden.',
      'qrStep3': 'Schritt 3: Klicken Sie auf die Schaltfläche Online bezahlen',
      'qrStep4': 'Schritt 4: In wenigen Sekunden erhalten Sie die Zahlungsbestätigung.',
      'qrCancel': 'Abbrechen',
      'qrText': 'Sie haben ',
      'qrText2': 'Sekunden Zeit, die Bestellung zu bezahlen, andernfalls wird sie storniert',
      'backShopping': 'Zurück zum Menü',
      'qr': 'Online durch Scannen des QR-Codes',
      'cash_waiter': 'Barzahlung bei der Servicekraft',
      'cash_bar': 'Barzahlung an der Bar',
      'pos_waiter': 'POS-Zahlung bei der Servicekraft',
      'pos_bar': 'KARTE/POS an der Bar',
      'card': 'Online-Zahlung',
      'counter': 'An der Kasse',
      'counter_cash': 'Barzahlung an der Kasse',
      'counter_pos': 'POS-Zahlung an der Kasse',
      'pack': 'Wo möchten Sie heute essen?',
      'takeAway': 'Zum Mitnehmen',
      'takeAway_first': 'Zum',
      'takeAway_second': 'Mitnehmen',
      'dineIn': 'Hier essen',
      'dineIn_first': 'Hier',
      'dineIn_second': 'essen',
      'paymentOptions': 'Zahlungsoptionen',
      'posOffline': 'Das Kartenterminal ist getrennt',
      'posRetry': 'Erneut versuchen',
      'weitingForAddToCartToFinish': 'Der Gesamtbetrag wird berechnet',
      'empty': 'Ihr Warenkorb ist leer',
      'backToMenu': 'Zurück zum Menü',
      'total': 'Gesamt:',
      'search': 'Suchen',
      'titleClient': 'Kunde',
      'titleMethod': 'Liefermethode',
      'titleLocation': 'Standort',
      'titleAdress': 'Lieferadresse',
      'titleStatus': 'Status',
      'done': 'Fertig',
      'datepicker': 'Datum auswählen',
      'hourpicker': 'Uhrzeit auswählen',
      'how_many': 'Für wie viele Personen wird die Reservierung vorgenommen',
      'tags': 'Bestellung von',
      'titlePopupTip': 'Betrag hinzufügen',
      'btnPopup': 'Hinzufügen',
      'titlePopupCoupon': 'Gutschein hinzufügen',
      'errorPopupCoupon': 'Falscher Gutschein',
      'errorProduct1': 'Die Produkte sind nicht mehr verfügbar und wurden aus dem Warenkorb entfernt',
      'errorProduct2': 'Ein oder mehrere Produkte sind nicht mehr verfügbar und wurden aus dem Warenkorb entfernt',
      'errorProduct3': 'Sie müssen Produkte im Warenkorb haben, um bestellen zu können!',
      'errorProduct4': 'Bitte wählen Sie die Methode und den Standort aus',
      'errorProduct5': 'Bitte fügen Sie einen Kunden hinzu',
      'errorProduct6': 'Keine Zahlungsmethode ausgewählt',
      'errorProduct7': 'Bitte fügen Sie eine Adresse hinzu',
      'add': 'Hinzufügen',
      'addFor': 'Hinzufügen für ',
      'edit': 'Bearbeiten',
      'next_to_option': 'Hinzufügen',
      'prev_to_option': 'Zurück',
      'infosup': 'Zusätzliche Informationen hinzufügen',
      'guest': 'Gast',
      'newScan': 'Scannen Sie erneut, um eine neue Bestellung zu beginnen.',
      'state': 'Landkreis',
      'city': 'Ort',
      'adress': 'Gebäude, Treppenhaus, Etage, Wohnung',
      'number': 'Nummer',
      'street': 'Straße',
      'adressname': 'Adressname',
      'sexf': 'Weiblich',
      'sexm': 'Männlich',
      'sex': 'Geschlecht',
      'birthdate': 'Geburtsdatum',
      'contactperson': 'Ansprechpartner',
      'newclient': 'Kunden hinzufügen oder auswählen',
      'newadress': 'Adresse hinzufügen oder auswählen',
      'save1': 'Auswählen und Änderungen speichern',
      'deliveryAdress': 'Adresse hinzufügen',
      'deliveryAdressEdit': 'Adresse bearbeiten',
      'firstName': 'Vorname',
      'lastName': 'Nachname',
      'contactPers': 'Ansprechpartner',
      'clientSelected': 'Ausgewählter Kunde',
      'clearFields': 'Felder leeren',
      'addAdress': '+ Adresse hinzufügen',
      'existingClient': 'Bestellung von',
      'orderNow': 'Bezahlen',
      'orderNowDesc': '⚠️ Bitte bezahlen Sie erst unmittelbar bevor Sie gehen. Bis dahin können Sie weitere Produkte aus dem Menü bestellen.',
      'viva_walet': 'Mit Karte am Gerät',
      'vivaWaitingText': 'Warten auf das Öffnen der Viva-App...',
      'vivaRetryButton': 'Erneut versuchen',
      'vivaCancelButton': 'Abbrechen',
      'pos': 'Mit Karte',
      'cash': 'Bargeld',
      'free': 'Kostenlos',
      'coment': 'Bestellkommentar',
      'addTip': 'Trinkgeld hinzufügen:',
      'addTipValue': 'Betrag eingeben',
      'addTipButton': 'Hinzufügen',
      'removeTip': 'Trinkgeld entfernen',
      'removeTipButton': 'Entfernen',
      'addCoupon': 'Rabattgutschein hinzufügen',
      'removeCoupon': 'Gutschein löschen',
      'removeCouponButton': 'Löschen',
      'modif': 'Bearbeiten',
      'delete': 'Löschen',
      'freeProd': 'Kostenloses Produkt',
      'info': 'Informationen',
      'orderDet': 'Bestelldetails',
      'cartDet': 'Mein Warenkorb',
      'fast': 'So schnell wie möglich',
      'selectHour': 'Uhrzeit auswählen',
      'selectPayment': 'Zahlungsmethode auswählen',
      'pleaseSelectMethodAndLoc': 'Bitte wählen Sie die Methode und den Standort aus!',
      'locSelect': 'Standort auswählen',
      'searchProduct': 'Produkte suchen',
      'phone': 'Telefon',
      'email': 'E-Mail',
      'inlocation': 'Vor Ort',
      'cuiPlaceholder': 'Umsatzsteuer-ID eingeben',
      'emailFieldsTitle1': 'Helfen Sie uns, das Erlebnis zu verbessern',
      'emailFieldsTitle2': 'Hinterlassen Sie uns eine E-Mail-Adresse, damit wir Ihnen die Bestellbestätigung senden können!',
      'emailPlaceholder': 'E-Mail-Adresse',
      'phonePlaceholder': 'Telefonnummer',
      'phoneFieldsTitle1': 'Geben Sie die Telefonnummer ein:',
      'phoneSearch': 'Hinzufügen',
      'client': 'Kunde:',
      'newClient': 'Neuer Kunde:',
      'phoneFidelityTitle': 'Treuepunkte laden?',
      'phoneFieldsTitle2': 'Oder scannen Sie den QR-Code aus der App',
      'phoneError': 'Ungültige Telefonnummer',
      'qrError': 'Ungültiger QR-Code. Scannen Sie erneut oder geben Sie die Telefonnummer ein!',
      'emailError': 'Ungültige E-Mail-Adresse',
      'adressNotInRange': 'Außerhalb des Liefergebiets, bitte ändern Sie die Adresse!',
      'adressNotCorect': 'Die Adresse ist nicht korrekt',
      'continueToPay': 'Weiter zur Zahlung',
      'loyalityNoSms': 'Möchten Sie Treuepunkte?',
      'noLoyalitySms': 'Möchten Sie wissen, wann die Bestellung fertig ist?',
      'loyalitySms': 'Möchten Sie wissen, wann Ihre Bestellung fertig ist, und Treuepunkte erhalten?',
      'new_client_fidelity': 'Nachdem Sie mit dieser Telefonnummer ein Konto in der App erstellt haben, werden die Treuepunkte diesem Konto automatisch gutgeschrieben.',
      'cardDesc1': 'Kartenzahlung wird verarbeitet',
      'cardDesc2': 'Bitte warten Sie einen Moment, während Ihre Transaktion verarbeitet wird',
      'cardDesc3': 'Vielen Dank für Ihre Geduld!'
    }
  },
  ro: {
    general: {
      tip: 'Bacșiș',
      confirm: 'Confirma',
      search: 'Caută',
      add: 'Adaugă',
      edit: 'Editează',
      delete: 'Șterge',
      remove: 'Elimină',
      save: 'Salvează',
      update: 'Actualizează',
      cancel: 'Anulează',
      cancel2: 'Renunță',
      continue: 'Continuă',
      activate: 'activează',
      deactivate: 'dezactivează',
      active: 'activ',
      inactive: 'inactiv',
      specialPrice: 'Preț Special',
      removePhoto: 'Prea multe imagini încărcate',
      yes: 'Da',
      no: 'Nu',
      success: 'Succes',
      required: 'necesar',
      back: 'Înapoi',
      next: 'Următorul',
      finish: 'Finalizează',
      duplicate: 'Duplică',
      select: 'Selectează',
      all: 'Toate',
      alls: 'Toti',
      reset: 'Resetează',
      export: 'Exportă',
      loadMore: 'Încarcă mai mult',
      viewDetails: 'Vezi Detalii',
      showing: '{length} rezultate afișate',
      enable: 'activezi',
      disable: 'dezactivezi',
      product: 'produsul',
      logout: 'Deconectare',
      from: 'de la',
      to: 'pana la',
      cancelCourier: 'Anulează curier',
      agree: 'De accord',
      agreePopupMessage: 'Pentru a permite browserului să redea sunete, trebuie să faceți clic pe butonul „De acord”. Aceasta va reda un sunet de test pentru a activa redarea sunetului in browser.',
      day: 'ziua',
      notCompleted: 'necompletat',
      saveChanges: 'Salvează schimbările',
      doYouWantToLogout: 'Vrei sa te deconectezi?',
      minutes: 'minute',
      hour: 'ora',
      hours: 'ore',
      deliveryMethod: 'Metode Livrare',
      customSort: 'Compania folosește sortarea custom',
      none: 'Niciunul',
      included: 'Inclus',
      error_fiscal_kiosk: 'Eroare imprimantă sau POS bancar. Vă rugăm să vă adresați casieriei și să solicitați ajutorul unui operator',
      error_not_open_kiosk: 'Kiosk Închis, Ne pare rău, dar kiosk-ul nostru este momentan închis, va rugăm reveniți în timpul programului de lucru',
      no_internet_kiosk: 'Internet indisponibil',
      reload: 'Reîncarcă',
      error_not_open_table: 'Trebuie să fii la masă pentru a comanda. Întoarce-te la masă și scanează din nou!',
      error_not_open_table_1: 'Linkul dumneavoastră nu este valid. Vă rugăm să mergeți la masă și să scanați din nou codul QR',
      error_not_open_table_2: 'Serviciul „Comandă la masă” nu este disponibil. Vă rugăm să vă adresați personalului',
      error_not_open_table_3: 'Serviciul „Comandă la masă” nu este disponibil. Vă rugăm să vă adresați personalului',
      error_not_open_table_4: 'Serviciul „Comandă la masă” nu este disponibil. Vă rugăm să vă adresați personalului',
      error_not_open_table_5: 'Serviciul „Comandă la masă” nu este disponibil. Vă rugăm să vă adresați personalului',
      error_not_open_table_6: 'Serviciul „Comandă la masă” nu este disponibil. Vă rugăm să vă adresați personalului',
      error_not_open_table_7: 'Linkul dumneavoastră nu este valid. Vă rugăm să mergeți la masă și să scanați din nou codul QR',
      error_not_open_table_8: 'Locația este în afara programului de lucru. Vă rugăm să așteptați până la ora deschiderii',
      error: 'Eroare',
      errProductLoad: 'Produsul nu a putut fi încărcat',
      errProductsLoad: 'Produsele nu au putut fi încărcate',
      errOrderMethod: 'Nu am putut salva alegerea pentru aici sau la pachet. Te rugăm să încerci din nou.',
      errPaymentProfileLoad: 'Metodele de plată nu au putut fi încărcate',
      loyaltyPoints: 'Puncte de loyalitate:',
      loyaltyPointsText: 'Total puncte de loialitate',
      applyLoyalty: 'Aplica punctele',
      removeLoyalty: 'Sterge punctele',
      walletTotalText: 'Total in wallet',
      applyWallet: 'Plateste din portofel',
      removeWallet: 'Sterge din comanda bani din portofel',
      walletAppNot1: 'Se asteapta aprobarea din aplicatie...',
      walletAppNot2: 'Dacă nu ai primit notificarea sau notificările nu sunt activate în aplicație, intră în contul tău și apasă pe opțiunea de autentificare în doi pași.',
      walletAppNotErr1: 'Eroare la trimiterea codului',
      walletAppNotErr2: 'Eroare verificare 2FA',
      walletAppNotErr3: 'Cererea a fost respinsa',
      selectWalletValue: 'Selecteaza valoarea pe care vrei sa o folosesti',
      selectWalletValueErr: 'Ai doar ',
      selectWalletValueErr2: 'In cos ai produse de ',
      walletPay: 'Platit cu wallet:',
    },
    addOrder: {
      'pleaseWait': 'Vă rog așteptați',
      'pleaseWaitFiscalReceipt': 'Vă rog așteptați bonul fiscal',
      'selectTip': 'Alege Bacșișul',
      'customTip': 'Altă Sumă',
      'enterCustomTip': 'Introdu Bacșișul',
      'tipAdded': 'Tips Adăugat',
      'removeTip': 'Șterge Tips',
      'outOfStock': 'Stoc Epuizat',
      'available': 'disponibile',
      'sufficientStock': 'Stoc suficient',
      'productNoStock': 'Produsul are stocul epuizat',
      'unavailable': 'Indisponibil',
      'productUnavailable': 'Produsul este momentan indisponibil',
      'addPager': 'Te rog sa introduci un pager inainte de plata',
      'vivaPaySuccess': 'Multumim, plata a fost efectuata cu succes!',
      'cart_lost': 'Alt Kiosk initializat',
      'cart_lost_title': 'A apărut o problemă',
      'err1': 'Va rugam selectati produsele ce vreti sa le platiti!',
      'askcashtxt': 'În câteva momente un ospătar va veni să vă încaseze',
      'waiter_called': 'Chelnerul a fost anuntat si va veni in scurt timp',
      'titlePopupEditFgpName': 'Cum te cheama?',
      'addPopupEditFgpName': 'Salveaza',
      'askFirstNameTitle': 'Care este prenumele tău?',
      'askFirstNameRequired': 'Te rugăm să îți introduci prenumele',
      'back': 'Inapoi',
      'close': 'Nu doresc',
      'allSelect': 'Selectează tot',
      'deselectAll': 'Deselectează tot',
      'productNavbar': 'Produs',
      'menuNavbar': 'Meniu',
      'payNavbar': 'Plată',
      'inProcesing': 'În pregătire',
      'inPrepared': 'Preparata',
      'openOrder': 'Trimite la bucatarie',
      'openOrderNotAvailable': 'Nu toate produsele sunt trimise',
      'waitingOpenOrder': 'Comanda ta este în pregătire și va fi gata în câteva momente.',
      'optionNavar': 'Opțiuni',
      'splashScreenOrderNow': 'Comandă acum',
      'ordersHistory': 'Vezi istoric comandă:',
      'orderNew': 'Comandă nouă',
      'chooseLanguage': 'Alege limba',
      'addToCart': 'Produsul a fost adăugat în coș',
      'order_id_freeze': 'Plata a fost inițiată. Vă rugăm să continuați plata sau să așteptați expirarea linkului de plată pentru a modifica comanda!',
      'euPlatesc_error': 'There was a problem with your request!',
      'euPlatesc_error1': 'Authentication failed',
      'euPlatesc_error2': 'Insufficient funds',
      'euPlatesc_error3': 'Transaction declined',
      'euPlatesc_error4': 'Card expired',
      'euPlatesc_error5': 'Invalid response',
      'relogin': 'Mai este cineva la masa? Daca nu sterge comanda anterioara!',
      'deleteOrder': 'Sterge',
      'couninueOrder': 'Continuă',
      'errorRelogin': 'Există o comandă deschisă! Te rog adresează-te chelnerului pentru a închide comanda!',
      'finishOrderMsg': 'Comanda ta a fost plasată cu succes! Rămâi la masă, mai departe ne ocupăm noi de tot!',
      'errorFinishOrderMsg': 'Plata eșuată! Va rugăm verificați datele introduse pentru plata! Incearcă din nou sau adresează-te ospătarului!',
      'payByCard': 'Plateste cu cardul',
      'payByCashMachine': 'Introduceți bancnotele în aparat',
      'payByCashMachineDone': 'Va rugam asteptati!',
      'howPay': 'Cum dorești să plătești?',
      'posGeneralError': 'Tranzacția a eșuat!',
      'selectMinMax': 'Poti selecta',
      'selectMin': ' minim',
      'selectMax': ' maxim',
      'cartBtn': 'Coșul meu',
      'emptyCartBtn': 'Golește coșul',
      'splashScreenWrapperStart': 'Atinge ecranul pentru a începe o comandă',
      'swipeUpTooltip': 'Derulează în jos pentru următoarea categorie',
      'resetQuestion': 'Doriți să începeți din nou?',
      'emptyCart': 'Doriți să stergeți toate produsele din coș?',
      'emptyCartProduct': 'Doriți să stergeți produsul din coș?',
      'yes': 'DA',
      'no': 'NU',
      'reorderPopupQuestion': 'Doriți să mai comandați ceva?',
      'soldWithAdd': 'Adaugă',
      'jumpOver': 'Sari peste',
      'soldWithNo': 'Nu doresc',
      'soldWithExtra': 'Total extra',
      'placeholderWaiter': '(ex. Nota de plată)',
      'sendWaiterValidate': 'Trebuie să introduceți un motiv!',
      'sendWaiter': 'Vrei sa chemi chelnerul?',
      'soldWithTitle': 'Recomandări',
      'menuCombo': 'V-ar plăcea să alegeți opțiunea de meniu complet?',
      'couponExit': 'Atinge oriunde pentru a ieși',
      'couponTitle': 'Introdu codul cuponului',
      'tipsValue': 'Introdu valoare:',
      'enterCui': 'Introdu CUI-ul',
      'noProductsFound': 'Produsele căutate nu au fost găsite.',
      'couponPlaceholder': 'Scrie codul cuponului',
      'pagerTitle': 'Scaneaza codul QR de pe pager',
      'pagerPlaceholder': 'Cod Pager',
      'pagerBtn': 'Adauga Pager',
      'couponBtn': 'Aplică cupon:',
      'commentBtn': 'Adaugă mentiuni comanda:',
      'couponButton': 'Aplică',
      'couponBtn2': 'Ai un cod promoțional?',
      'orderNumber': 'Număr comandă',
      'step1': 'Așteptați ca numărul comenzii să apară pe ecran',
      'step2': 'Ridicați comanda de la casă',
      'yourOrderNr': 'Număr comandă',
      'doneShortly': 'Comanda dvs. este în pregătire.',
      'thenks': 'Mulțumim!',
      'qrStep1': 'Pasul 1: Scanează codul QR cu camera de la smartphone.',
      'qrStep2': 'Pasul 2: Accesează link-ul, completează câmpurile (numărul de card, emailul) și bifează căsuțele. Atenție! Acceptarea termenilor și condițiilor este obligatorie, altfel nu se poate realiza plata.',
      'qrStep3': 'Pasul 3: Click pe butonul Plătește online',
      'qrStep4': 'Pasul 4: În câteva secunde vei primi confirmarea plății.',
      'qrCancel': 'Anulează',
      'qrText': 'Aveți la dispoziție ',
      'qrText2': 'secunde pentru a plăti comanda sau comanda va fi anulată',
      'backShopping': 'Înapoi la meniu',
      'qr': 'Online scanând codul QR',
      'cash_waiter': 'Cash la ospatar',
      'cash_bar': 'Cash la bar',
      'pos_waiter': 'POS la ospatar',
      'pos_bar': 'CARD/POS la bar',
      'card': 'Plată Online',
      'counter': 'La casă',
      'counter_cash': 'La casă cash',
      'counter_pos': 'La casă POS',
      'pack': 'Unde vei lua masa astăzi?',
      'takeAway': 'La pachet',
      'takeAway_first': 'La',
      'takeAway_second': 'pachet',
      'dineIn': 'În locație',
      'dineIn_first': 'Mănâncă',
      'dineIn_second': 'în locație',
      'paymentOptions': 'Opțiuni de Plată',
      'posOffline': 'Posul bancar este deconectat',
      'posRetry': 'Reîncearcă',
      'weitingForAddToCartToFinish': 'Se calculeaza totalul...',
      'empty': 'Coșul tău este gol',
      'backToMenu': 'Inapoi la meniu',
      'total': 'Total:',
      "noProductsMessage": "În acest interval de timp, nu există produse disponibile în această categorie.",
      'search': 'Caută produse',
      'titleClient': 'Detalii client',
      'titleMethod': 'Metoda livrare',
      'titleLocation': 'Locatie',
      'titleAdress': 'Adresa livrare',
      'titleStatus': 'Status',
      'done': 'Gata',
      'tip': 'Bacșiș',
      'datepicker': 'Alege data de livrare',
      'hourpicker': 'Alege ora de livrare',
      'how_many': 'Pentru cate persoame se face rezervarea',
      'tags': 'Comanda din',
      'titlePopupTip': 'Adaugă Valoarea',
      'btnPopup': 'Adaugă',
      'titlePopupCoupon': 'Adaugă cupon',
      'errorPopupCoupon': 'Cupon gresit',
      'errorProduct1': 'Produsele nu mai sunt disponibile și au fost șterse din coș',
      'errorProduct2': 'Unul sau mai multe produse nu mai sunt disponibile și au fost șterse din coș',
      'errorProduct3': 'Trebuie sa aveti produse in cos pentru a putea comanda!',
      'errorProduct4': 'Te rugam sa selectezi metoda si locatia',
      'errorProduct5': 'Te rog adaugă un client',
      'errorProduct6': 'Metoda de plata neselectata',
      'errorProduct7': 'Te rog adaugă o adresa',
      'add': 'Adaugă',
      'addFor': 'Adaugă pentru ',
      'edit': 'Editează',
      'next_to_option': 'Adaugă',
      'prev_to_option': 'Inapoi',
      'infosup': 'Adaugă informații suplimentare',
      'state': 'Județ',
      'city': 'Oraș',
      'adress': 'Bloc, scară, etaj, apartament',
      'number': 'Număr',
      'street': 'Strada',
      'adressname': 'Nume Adresa',
      'sexf': 'Feminin',
      'sexm': 'Masculin',
      'sex': 'Sex',
      'birthdate': 'Data nașterii',
      'contactperson': 'Persoana de contact',
      'newclient': 'Adaugă un client',
      'newadress': 'Adaugă sau alege adresa ',
      'save1': 'Alege si salveaza modificarile',
      'deliveryAdress': 'Adaugă o adresa noua',
      'deliveryAdressEdit': 'Editează adresa',
      'firstName': 'Prenume',
      'lastName': 'Nume',
      'contactPers': 'Persoana de contact',
      'clientSelected': 'Client selectat',
      'clearFields': 'Gloeste Campurile',
      'addAdress': '+ Adaugă adresa',
      'existingClient': 'Comanda trimisa din',
      'orderNow': 'Plătește',
      'orderNowDesc': '⚠️ Vă rugăm să plătiți doar la plecare. Până atunci, puteți comanda în continuare alte produse din meniu.',
      'viva_walet': 'Cu cardul pe dispozitiv',
      'vivaWaitingText': 'Se așteaptă deschiderea aplicației Viva...',
      'vivaRetryButton': 'Reîncearcă',
      'vivaCancelButton': 'Anulează',
      'pos': 'Cu cardul',
      'cash': 'Cash',
      'free': 'Gratis',
      'coment': 'Comentariu Comanda',
      'addTip': 'Adaugă bacșiș:',
      'addTipValue': 'Introdu valoare',
      'addTipButton': 'Adaugă',
      'removeTip': 'Sterge bacșiș',
      'removeTipButton': 'Sterge',
      'addCoupon': 'Adaugă cupon de reducere',
      'removeCoupon': 'Sterge cupon',
      'removeCouponButton': 'Sterge',
      'modif': 'Modifică',
      'delete': 'Sterge',
      'freeProd': 'Produs Gratuit',
      'info': 'Info',
      'guest': 'Oaspete',
      'newScan': 'Pentru a începe o comandă nouă, vă rugăm să scanați din nou.',
      'orderDet': 'Detalii Comandă',
      'cartDet': 'Coșul meu',
      'fast': 'Cat mai rapid',
      'selectHour': 'Selecteaza ora',
      'selectPayment': 'Selecteaza metoda de plata',
      'pleaseSelectMethodAndLoc': 'Va rugam sa selectati metoda si locatia!',
      'locSelect': 'Selectati o locatie',
      'searchProduct': 'caută produse',
      'phone': 'Telefon',
      'email': 'E-mail',
      'inlocation': 'In Locatie',
      'cuiPlaceholder': 'Vrei CUI pe bon?',
      'emailFieldsTitle1': 'Ajută-ne să îmbunătățim experiența',
      'emailFieldsTitle2': 'Lasă-ne un email pentru a-ți trimite confirmarea comenzii!',
      'emailPlaceholder': 'Adresa e-mail',
      'phonePlaceholder': 'Numar Telefon',
      'phoneFieldsTitle1': 'Introdu numărul de telefon:',
      'phoneSearch': 'Introdu',
      'client': 'Client:',
      'newClient': 'Client Nou:',
      'phoneFidelityTitle': 'Încarcă puncte de fidelitate?',
      'phoneFieldsTitle2': 'Sau scanează codul QR din aplicație',
      'phoneError': 'Telefon invalid',
      'qrError': 'Cod Qr invalid, scaneaza din nou sau introdu numarul de telefon!',
      'emailError': 'Email invalid',
      'adressNotInRange': 'Esti prea departe, te rog schimba adresa!',
      'adressNotCorect': 'Adresa nu este corecta',
      'continueToPay': 'Continuă spre plată',
      'loyalityNoSms': 'Vrei puncte de loialitate?',
      'noLoyalitySms': 'Vrei să știi când este gata comanda?',
      'loyalitySms': 'Vrei să știi când este gata comanda și să primești puncte de loialitate?',
      'new_client_fidelity': 'După crearea unui cont în aplicație cu acest număr de telefon, punctele de loialitate vor fi atrbuite în mod automat contului respectiv.',
      'cardDesc1': 'Plata cu cardul în curs de procesare',
      'cardDesc2': 'Vă rugăm să așteptați câteva momente în timp ce tranzacția dvs. este procesată',
      'cardDesc3': 'Vă mulțumim pentru răbdare!'
    }
  },
  hu: {
    general: {
      tip: 'Borravaló',
      confirm: 'Megerősít',
      search: 'Keresés',
      add: 'Hozzáadás',
      edit: 'Szerkesztés',
      delete: 'Törlés',
      remove: 'Eltávolítás',
      save: 'Mentés',
      update: 'Frissítés',
      cancel: 'Mégse',
      cancel2: 'Mégse',
      continue: 'Folytatás',
      activate: 'aktiválás',
      deactivate: 'deaktiválás',
      active: 'aktív',
      inactive: 'inaktív',
      specialPrice: 'Különleges Ár',
      removePhoto: 'Túl sok kép feltöltve',
      yes: 'Igen',
      no: 'Nem',
      success: 'Siker',
      required: 'kötelező',
      back: 'Vissza',
      next: 'Következő',
      finish: 'Befejezés',
      duplicate: 'Másolat',
      select: 'Kiválasztás',
      all: 'Minden',
      alls: 'Minden',
      reset: 'Visszaállítás',
      export: 'Exportálás',
      loadMore: 'Továbbiak betöltése',
      viewDetails: 'Részletek megtekintése',
      showing: '{length} találat megjelenítve',
      enable: 'aktiválás',
      disable: 'deaktiválás',
      product: 'termék',
      logout: 'Kijelentkezés',
      from: '-tól',
      to: '-ig',
      cancelCourier: 'Futár lemondása',
      agree: 'Egyetértek',
      agreePopupMessage: 'Ahhoz, hogy a böngésző lejátszhassa a hangot, kattintson az „Egyetértek" gombra. Ez egy teszthangot játszik le a hang lejátszásának aktiválásához.',
      day: 'nap',
      notCompleted: 'nincs kitöltve',
      saveChanges: 'Változtatások mentése',
      doYouWantToLogout: 'Szeretne kijelentkezni?',
      minutes: 'perc',
      hour: 'óra',
      hours: 'óra',
      deliveryMethod: 'Szállítási módok',
      customSort: 'A cég egyedi rendezést használ',
      none: 'Egyik sem',
      included: 'Tartalmazott',
      error_fiscal_kiosk: 'Pénztárgép hiba, kérjük hívjon egy alkalmazottat',
      error_not_open_kiosk: 'Zárva van!',
      no_internet_kiosk: 'Nincs internetkapcsolat',
      reload: 'Újratöltés',
      error_not_open_table: 'A rendeléshez az asztalnál kell lennie. Térjen vissza az asztalhoz, és szkennelje újra!',
      error_not_open_table_1: 'A linkje nem érvényes. Kérjük, menjen az asztalhoz, és szkennelje újra a QR-kódot',
      error_not_open_table_2: 'Az „Asztalhoz rendelés" szolgáltatás nem elérhető. Kérjük, forduljon a személyzethez',
      error_not_open_table_3: 'Az „Asztalhoz rendelés" szolgáltatás nem elérhető. Kérjük, forduljon a személyzethez',
      error_not_open_table_4: 'Az „Asztalhoz rendelés" szolgáltatás nem elérhető. Kérjük, forduljon a személyzethez',
      error_not_open_table_5: 'Az „Asztalhoz rendelés" szolgáltatás nem elérhető. Kérjük, forduljon a személyzethez',
      error_not_open_table_6: 'Az „Asztalhoz rendelés" szolgáltatás nem elérhető. Kérjük, forduljon a személyzethez',
      error_not_open_table_7: 'A linkje nem érvényes. Kérjük, menjen az asztalhoz, és szkennelje újra a QR-kódot',
      error_not_open_table_8: 'A helyszín a nyitvatartási időn kívül van. Kérjük, várjon a nyitásig',
      error: 'Hiba',
      errProductLoad: 'A terméket nem sikerült betölteni',
      errProductsLoad: 'A termékeket nem sikerült betölteni',
      errOrderMethod: 'Nem sikerült menteni a választást. Kérjük, próbáld újra.',
      errPaymentProfileLoad: 'A fizetési módokat nem sikerült betölteni',
      loyaltyPoints: 'Hűségpontok:',
      loyaltyPointsText: 'Összes hűségpont',
      applyLoyalty: 'Pontok alkalmazása',
      removeLoyalty: 'Pontok eltávolítása',
      walletTotalText: 'Összes a pénztárcában',
      applyWallet: 'Fizetés pénztárcából',
      removeWallet: 'Pénz eltávolítása a pénztárcából a rendelésből',
      walletAppNot1: 'Várakozás az alkalmazás jóváhagyására...',
      walletAppNot2: 'Ha nem kapta meg az értesítést, vagy az értesítések nincsenek engedélyezve az alkalmazásban, lépjen be a fiókjába, és érintse meg a kétlépcsős hitelesítés opciót.',
      walletAppNotErr1: 'Hiba a kód küldésekor',
      walletAppNotErr2: '2FA ellenőrzési hiba',
      walletAppNotErr3: 'A kérés elutasítva',
      selectWalletValue: 'Válassza ki a használni kívánt összeget',
      selectWalletValueErr: 'Csak ennyi van: ',
      selectWalletValueErr2: 'A kosarában ennyi értékű termékek vannak: ',
      walletPay: 'Fizetés pénztárcából:',
    },
    addOrder: {
      'pleaseWait': 'Kérjük, várjon',
      'pleaseWaitFiscalReceipt': 'Kérjük, várjon a nyugtára',
      'selectTip': 'Válassza ki a borravalót',
      'customTip': 'Egyedi összeg',
      'enterCustomTip': 'Adja meg az egyedi borravalót',
      'tipAdded': 'Borravaló hozzáadva',
      'removeTip': 'Borravaló eltávolítása',
      'outOfStock': 'Elfogyott',
      'available': 'elérhető',
      'sufficientStock': 'Elegendő készlet',
      'productNoStock': 'A termék elfogyott',
      'unavailable': 'Nem elérhető',
      'productUnavailable': 'A termék jelenleg nem elérhető',
      'addPager': 'Kérjük, adjon meg egy pagert a fizetés előtt',
      'vivaPaySuccess': 'Köszönjük, a fizetés sikeresen megtörtént!',
      'cart_lost': 'Egy másik kioszk észlelve.',
      'cart_lost_title': 'Hiba történt',
      'err1': 'Kérjük, válassza ki a fizetni kívánt termékeket!',
      'askcashtxt': 'Néhány pillanaton belül egy pincér jön a fizetés begyűjtésére',
      'waiter_called': 'A pincért értesítették, és hamarosan megérkezik',
      'back': 'Vissza',
      'titlePopupEditFgpName': 'Mi a neve?',
      'addPopupEditFgpName': 'Mentés',
      'askFirstNameTitle': 'Mi a keresztneve?',
      'askFirstNameRequired': 'Kérjük, adja meg a keresztnevét',
      'waitingOpenOrder': 'A rendelése készül, és néhány pillanaton belül elkészül.',
      'close': 'Bezárás',
      'allSelect': 'Összes kiválasztása',
      'inProcesing': 'Feldolgozás alatt',
      'inPrepared': 'Elkészült',
      'deselectAll': 'Összes kijelölés megszüntetése',
      'openOrder': 'Rendelés leadása',
      'openOrderNotAvailable': 'Nem minden termék elküldve',
      'productNavbar': 'Termék',
      'menuNavbar': 'Menü',
      'payNavbar': 'Fizetés',
      'optionNavar': 'Opciók',
      'chooseLanguage': 'Válassza ki a nyelvét',
      'tip': 'Borravalók',
      'tipsValue': 'Adja meg az értéket:',
      'splashScreenOrderNow': 'Rendeljen most',
      'ordersHistory': 'Rendelési előzmények megtekintése:',
      'orderNew': 'Új rendelés',
      'addToCart': 'A termék hozzáadva a kosárhoz',
      'order_id_freeze': 'A fizetés elkezdődött. Kérjük, folytassa a fizetést, vagy várja meg a fizetési link lejáratát a rendelés módosításához!',
      'euPlatesc_error1': 'Hitelesítés sikertelen',
      'euPaysc_error2': 'Nincs elegendő fedezet',
      'euPaycesc_error3': 'Tranzakció sikertelen',
      'euPaycesc_error4': 'A kártya lejárt',
      'euPlatesc_error5': 'Érvénytelen válasz',
      "noProductsMessage": "Ebben az időpontban nincsenek elérhető termékek ebben a kategóriában.",
      'relogin': 'Van még valaki az asztalnál? Ha nincs, törölje az előző rendelést!',
      'deleteOrder': 'Törlés',
      'couninueOrder': 'Folytatás',
      'errorRelogin': 'Van egy nyitott rendelés! Kérjük, forduljon a pincérhez a rendelés lezárásához!',
      'finishOrderMsg': 'A rendelése sikeresen leadva! Maradjon az asztalnál, mi mindenről gondoskodunk!',
      'errorFinishOrderMsg': 'Fizetés sikertelen! Kérjük, ellenőrizze a fizetéshez megadott adatokat! Próbálja újra, vagy kérdezze meg a pincért!',
      'payByCard': 'Fizetés kártyával',
      'payByCashMachine': 'Helyezze be a bankjegyeket a gépebe',
      'payByCashMachineDone': 'Kérjük, várjon!',
      'howPay': 'Hogyan szeretne fizetni?',
      'posGeneralError': 'Tranzakció sikertelen!',
      'selectMinMax': 'Kiválaszthat',
      'selectMin': ' minimum',
      'selectMax': ' maximum',
      'cartBtn': 'A kosaram',
      'emptyCartBtn': 'Kosár ürítése',
      'splashScreenWrapperStart': 'Érintse meg a képernyőt a rendelés elindításához',
      'swipeUpTooltip': 'Csúsztasson a következő kategóriához',
      'resetQuestion': 'Szeretne elölről kezdeni?',
      'emptyCart': 'Szeretné törölni az összes terméket a kosárból?',
      'emptyCartProduct': 'Szeretné törölni a terméket a kosárból?',
      'yes': 'Igen',
      'no': 'Nem',
      'jumpOver': 'Kihagyás',
      'soldWithAdd': 'Hozzáadás',
      'soldWithNo': 'Nem, köszönöm',
      'soldWithExtra': 'Összes extra',
      'placeholderWaiter': '(pl. fizetési számla)',
      'sendWaiterValidate': 'Meg kell adnia egy indoklást!',
      'sendWaiter': 'Szeretné hívni a pincért?',
      'soldWithTitle': 'Ajánlás',
      'menuCombo': 'Szeretné választani az étkezési opciót?',
      'couponExit': 'Érintse meg bárhová a kilépéshez',
      'couponTitle': 'Adja meg a kuponkódot',
      'enterCui': 'Adja meg a CUI-t',
      'noProductsFound': 'A keresett termékek nem találhatók.',
      'couponPlaceholder': 'Írja be a kuponkódot',
      'pagerTitle': 'Szkennelje be a pageren lévő QR-kódot',
      'pagerPlaceholder': 'Pager kód',
      'pagerBtn': 'Pager hozzáadása',
      'couponBtn': 'Kupon alkalmazása:',
      'commentBtn': 'További információk:',
      'couponButton': 'Alkalmazás',
      'couponBtn2': 'Van promóciós kódja?',
      'orderNumber': 'Rendelési szám',
      'step1': 'Várja meg, amíg a rendelési szám megjelenik a képernyőn',
      'step2': 'Vegye át a rendelését a pénztárnál',
      'yourOrderNr': 'Rendelési szám',
      'doneShortly': 'A rendelése készül.',
      'thenks': 'Köszönjük!',
      'qrStep1': '1. lépés: Szkennelje be a QR-kódot a smartphone kamerájával.',
      'qrStep2': '2. lépés: Nyissa meg a linket, töltse ki a mezőket (kártyaszám, email), és jelölje be a négyzeteket. Figyelem! A feltételek elfogadása kötelező, különben a fizetés nem lehetséges.',
      'qrStep3': '3. lépés: Kattintson a Fizessen online gombra',
      'qrStep4': '4. lépés: Néhány másodpercen belül megkapja a fizetési visszaigazolást.',
      'qrCancel': 'Mégse',
      'qrText': 'Önnek van ',
      'qrText2': 'másodperce a rendelés kifizetésére, különben a rendelés törlődik',
      'backShopping': 'Vissza a menübe',
      'qr': 'Online a QR-kód szkennelésével',
      'cash_waiter': 'Készpénz a pincérnek',
      'cash_bar': 'Készpénz a bárnál',
      'pos_waiter': 'POS a pincérnek',
      'pos_bar': 'KÁRTYA/POS a bárnál',
      'card': 'Online fizetés',
      'counter': 'A pénztárnál',
      'counter_cash': 'A pénztárnál készpénz',
      'counter_pos': 'A pénztárnál POS',
      'pack': 'Hol fog ma étkezni?',
      'takeAway': 'Elvitelre',
      'takeAway_first': 'El',
      'takeAway_second': 'vitelre',
      'dineIn': 'Helyben fogyasztás',
      'dineIn_first': 'Helyben',
      'dineIn_second': 'fogyasztás',
      'paymentOptions': 'Fizetési opciók',
      'posOffline': 'A kártyaterminál nincs csatlakoztatva',
      'posRetry': 'Újrapróbálkozás',
      'weitingForAddToCartToFinish': 'Az összeg számítása folyamatban',
      'empty': 'A kosara üres',
      'backToMenu': 'Vissza a menübe',
      'total': 'Összesen:',
      'search': 'Keresés',
      'titleClient': 'Ügyfél',
      'titleMethod': 'Szállítási mód',
      'titleLocation': 'Helyszín',
      'titleAdress': 'Szállítási cím',
      'titleStatus': 'Állapot',
      'done': 'Kész',
      'datepicker': 'Válasszon dátumot',
      'hourpicker': 'Válasszon órát',
      'how_many': 'Hány főre készül a foglalás',
      'tags': 'Rendelés innen',
      'titlePopupTip': 'Érték hozzáadása',
      'btnPopup': 'Hozzáadás',
      'titlePopupCoupon': 'Kupon hozzáadása',
      'errorPopupCoupon': 'Hibás kupon',
      'errorProduct1': 'A termékek már nem elérhetők, és törölve lettek a kosárból',
      'errorProduct2': 'Egy vagy több termék már nem elérhető, és törölve lett a kosárból',
      'errorProduct3': 'A rendeléshez termékeket kell tennie a kosárba!',
      'errorProduct4': 'Kérjük, válassza ki a módot és a helyszínt',
      'errorProduct5': 'Kérjük, adjon hozzá egy ügyfelet',
      'errorProduct6': 'Fizetési mód nincs kiválasztva',
      'errorProduct7': 'Kérjük, adjon hozzá egy címet',
      'add': 'Hozzáadás',
      'addFor': 'Hozzáadás ehhez: ',
      'edit': 'Szerkesztés',
      'next_to_option': 'Hozzáadás',
      'prev_to_option': 'Előző',
      'infosup': 'További információk hozzáadása',
      'guest': 'Vendég',
      'newScan': 'Új rendelés elindításához kérjük, szkennelje újra.',
      'state': 'Megye',
      'city': 'Város',
      'adress': 'Épület, lépcsőház, emelet, lakás',
      'number': 'Szám',
      'street': 'Utca',
      'adressname': 'Cím neve',
      'sexf': 'Nő',
      'sexm': 'Férfi',
      'sex': 'Nem',
      'birthdate': 'Születési dátum',
      'contactperson': 'Kapcsolattartó személy',
      'newclient': 'Ügyfél hozzáadása vagy kiválasztása',
      'newadress': 'Cím hozzáadása vagy kiválasztása',
      'save1': 'Válasszon és mentse a változtatásokat',
      'deliveryAdress': 'Cím hozzáadása',
      'deliveryAdressEdit': 'Cím szerkesztése',
      'firstName': 'Keresztnév',
      'lastName': 'Vezetéknév',
      'contactPers': 'Kapcsolattartó személy',
      'clientSelected': 'Kiválasztott ügyfél',
      'clearFields': 'Mezők törlése',
      'addAdress': '+ Cím hozzáadása',
      'existingClient': 'Rendelés innen',
      'orderNow': 'Fizetés',
      'orderNowDesc': '⚠️ Kérjük, fizessen csak közvetlenül az indulás előtt. Addig tovább rendelhet más termékeket a menüből.',
      'viva_walet': 'Kártyával az eszközön',
      'vivaWaitingText': 'Várakozás a Viva alkalmazás megnyitására...',
      'vivaRetryButton': 'Újrapróbálkozás',
      'vivaCancelButton': 'Mégse',
      'pos': 'Kártyával',
      'cash': 'Készpénz',
      'free': 'Ingyenes',
      'coment': 'Rendelés megjegyzés',
      'addTip': 'Borravaló hozzáadása:',
      'addTipValue': 'Adja meg az összeget',
      'addTipButton': 'Hozzáadás',
      'removeTip': 'Borravaló eltávolítása',
      'removeTipButton': 'Eltávolítás',
      'addCoupon': 'Kedvezményes kupon hozzáadása',
      'removeCoupon': 'Kupon törlése',
      'removeCouponButton': 'Törlés',
      'modif': 'Szerkesztés',
      'delete': 'Törlés',
      'freeProd': 'Ingyenes termék',
      'info': 'Információ',
      'orderDet': 'Rendelés részletei',
      'cartDet': 'A kosaram',
      'fast': 'A lehető leggyorsabban',
      'selectHour': 'Válassza ki az időpontot',
      'selectPayment': 'Válassza ki a fizetési módot',
      'pleaseSelectMethodAndLoc': 'Kérjük, válassza ki a módot és a helyszínt!',
      'locSelect': 'Válasszon helyszínt',
      'searchProduct': 'termékek keresése',
      'phone': 'Telefon',
      'email': 'E-mail',
      'inlocation': 'Helyszínen',
      'cuiPlaceholder': 'Adja meg az adószámot',
      'emailFieldsTitle1': 'Segítsen nekünk javítani az élményt',
      'emailFieldsTitle2': 'Hagyjon egy email címet, hogy elküldhessük a rendelés visszaigazolását!',
      'emailPlaceholder': 'Email cím',
      'phonePlaceholder': 'Telefonszám',
      'phoneFieldsTitle1': 'Adja meg a telefonszámot:',
      'phoneSearch': 'Hozzáadás',
      'client': 'Ügyfél:',
      'newClient': 'Új ügyfél:',
      'phoneFidelityTitle': 'Hűségpontok betöltése?',
      'phoneFieldsTitle2': 'Vagy szkennelje be a QR-kódot az alkalmazásból',
      'phoneError': 'Érvénytelen telefonszám',
      'qrError': 'Érvénytelen QR-kód, szkennelje újra, vagy adja meg a telefonszámot!',
      'emailError': 'Érvénytelen email',
      'adressNotInRange': 'Nincs a hatótávolságon belül, kérjük változtassa meg a címet!',
      'adressNotCorect': 'A cím nem helyes',
      'continueToPay': 'Folytatás a fizetéshez',
      'loyalityNoSms': 'Szeretne hűségpontokat?',
      'noLoyalitySms': 'Szeretné tudni, mikor készül el a rendelés?',
      'loyalitySms': 'Szeretné tudni, mikor készül el a rendelés, és hűségpontokat kapni?',
      'new_client_fidelity': 'Miután létrehozott egy alkalmazásbeli fiókot ezzel a telefonszámmal, a hűségpontok automatikusan hozzárendelésre kerülnek ehhez a fiókhoz.',
      'cardDesc1': 'Kártyás fizetés feldolgozása',
      'cardDesc2': 'Kérjük, várjon néhány pillanatot, amíg a tranzakciója feldolgozásra kerül',
      'cardDesc3': 'Köszönjük a türelmét!'
    }
  },
}

export default messages
